// Auto-généré par scripts/groupImages.js
// Structure des données par collection
// Images groupées depuis /public/collection/

export const collectionsData = {
  'Abella': {
    slug: 'abella',
    categories: ['Intérieur', 'Salle de Bain', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/abella/abella-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-render-2.png',
    products: [
      {
        id: 0,
        name: 'Abella 40x120',
        color: 'Blanc',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/abella/abella-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Abella Dekofon 40x120',
        color: 'Décor',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/abella/abella-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Abella 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/abella/abella-blanc-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
    ],
    documents: [],
    commonSpecs: {
      finition: 'Mat',
      design: 'Marbre',
    }
  },
  'Adel': {
    slug: 'adel',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-render-2.png',
    products: [
      {
        id: 0,
        name: 'Adel White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-blanc.png',
        faces: [
          ''
        ],
        specifications: {},
      },
      {
        id: 1,
        name: 'Adel Ivory 60x120',
        color: 'Ivoire',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-ivory.png',
        faces: [
          ''
        ],
        specifications: {},
      },
      {
        id: 2,
        name: 'Adel Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adel/adel-gris.png',
        faces: [
          ''
        ],
        specifications: {},
      },
    ],
    documents: [],
    commonSpecs: {
      finition: 'Mat',
      design: 'Marbre',
    },
  },
  'Adela': {
    slug: 'adela',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-render.png',
    products: [
      {
        id: 0,
        name: 'Adela Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Adela Beyaz Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-blanc-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Adela Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Adela Grey Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-gris-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Adela Antrasit 30x90',
        color: 'Anthracite',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Adela Antrasit Dekofon 30x90',
        color: 'Anthracite Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-anthracite-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Adela White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adela/adela-white-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/adelahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Adonis': {
    slug: 'adonis',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adonis/adonis-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adonis/adonis-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adonis/adonis-render-2.png',
    products: [
      {
        id: 0,
        name: 'Adonis Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adonis/adonis-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Adonis Beyaz Dekofon 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adonis/adonis-dekofon.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Adonis Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Fon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adonis/adonis-blanc.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Adria': {
    slug: 'adria',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-render-3.png',
    products: [
      {
        id: 0,
        name: 'ADRIA ANTRASIT YER KAROSU',
        color: 'Anthracite',
        size: '',
        surface: 'Sol',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-anthracite.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Adria Antrasit 30x90',
        color: 'Anthracite',
        size: '30x90',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-blanc-dekofon.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Adria Kahve 30x90',
        color: 'Brun',
        size: '30x90',
        surface: 'Mural',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-cafe.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'ADRIA KAHVE YER KAROSU',
        color: 'Brun',
        size: '',
        surface: 'Sol',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-blanc.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 4,
        name: 'Adria Mix Dekofon 30x90',
        color: 'Mix',
        size: '30x90',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-mix-dekofon.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 5,
        name: 'Adria Beyaz Dekofon 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-white-60x60.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 6,
        name: 'Adria Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mural',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-blanc-dekofon.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 7,
        name: 'ADRIA WHITE YER KAROSU',
        color: 'Blanc',
        size: '',
        surface: 'Sol',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-blanc-dekofon.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 8,
        name: 'Adria Beyaz 60x60',
        color: 'Beyaz',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/adria/adria-white-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Agrilion': {
    slug: 'agrilion',
    categories: ['Jardin'],
    mainImage: '/collection/CONCEPT 60X120.jpg',
    products: [
      {
        id: 0,
        name: 'Agrilion Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/agreylion/agrilion-gris.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Agrilion Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/agreylion/agrilion-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Agrilion Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/agreylion/agrilion-bone.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/agrilionhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Agusta': {
    slug: 'agusta',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/agusta/agusta-cafe.jpg',
    products: [
      {
        id: 0,
        name: 'Agusta Coffee 30x60',
        color: 'Café',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/agusta/agusta-cafe.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Agusta Latte 30x60',
        color: 'Latte',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/agusta/agusta-latte.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/agustahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Alba': {
    slug: 'alba',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba-render.png',
    products: [
      {
        id: 0,
        name: 'Alba 19.7x19.7',
        color: '',
        size: '19.7x19.7',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba-autumn.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Alba Autumn 19.7x19.7',
        color: 'Automne',
        size: '19.7x19.7',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba-spring.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Alba Spring 19.7x19.7',
        color: 'Printemps',
        size: '19.7x19.7',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba-summer.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Alba Summer 19.7x19.7',
        color: 'Été',
        size: '19.7x19.7',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba-winter.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 4,
        name: 'Alba Winter 19.7x19.7',
        color: 'Hiver',
        size: '19.7x19.7',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alba/alba.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Albero': {
    slug: 'albero',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/albero/albero-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/albero/albero-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/albero/albero-render-2.png',
    products: [
      {
        id: 0,
        name: 'Albero Eboni 60x60',
        color: 'Ébène',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/albero/albero-eboni.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Albero Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/albero/albero-gris.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Albero Oak 60x60',
        color: 'Chêne',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/albero/albero-oak.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Alboran': {
    slug: 'alboran',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alboran/alboran-render.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alboran/alboran-render-2.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alboran/alboran-beige.jpg',
    products: [
      {
        id: 0,
        name: 'Alboran Beige 30x60',
        color: 'Beige',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alboran/alboran-beige.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Alboran Grey 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alboran/alboran-gris.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/alboranhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Aldonsa': {
    slug: 'aldonsa',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aldonsa/aldonsa-render.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aldonsa/aldonsa-render.jpg',
    products: [
      {
        id: 0,
        name: 'Aldonsa 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aldonsa/aldonsa.png',
        faces: [
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Alin': {
    slug: 'alin',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alin/alin-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alin/alin-render.png',
    products: [
      {
        id: 0,
        name: 'Alin 30x90',
        color: '',
        size: '30x90',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alin/alin-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'ALIN 45X45',
        color: '',
        size: '45x45',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alin/alin-dekofon.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Alin Dekofon 30x90',
        color: '',
        size: '30x90',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alin/alin.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Alin 60x60',
        color: '',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alin/alin-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Altus': {
    slug: 'altus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/altus/altus-render.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/altus/altus-render.jpg',
    products: [
      {
        id: 0,
        name: 'Altus 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/altus/altus.png',
        faces: [
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Alyssa': {
    slug: 'alyssa',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alyssa/alyssa-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alyssa/alyssa-render.png',
    products: [
      {
        id: 0,
        name: 'Alyssa Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alyssa/alyssa-anthracite.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Alyssa Bone 60x60',
        color: 'Beige',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alyssa/alyssa-bone.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Alyssa Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/alyssa/alyssa-gris.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Amethist': {
    slug: 'amethist',
    categories: ['Jardin'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/amethist/amethist-render.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/amethist/amethist-render-2.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-render-2.png',
    products: [
      {
        id: 0,
        name: 'Anti Asit_33x33 Beige',
        color: 'Beige',
        size: '33x33',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-beige.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Anti Asit_33x33 Blanc',
        color: 'Blanc',
        size: '33x33',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-blanc.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Anti Asit_33x33 Grey',
        color: 'Gris',
        size: '33x33',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-gris.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Amethist Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/amethist/amethist-anthracite.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 4,
        name: 'Amethist Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/amethist/amethist-gris.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },

  'Antares': {
    slug: 'antares',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antares/antares.jpg',
    products: [
      {
        id: 0,
        name: 'Antares',
        color: '',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antares/antares.jpg',
        faces: [''],
        specifications: {},
      },
      {
        id: 1,
        name: 'Antares 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antares/antares.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [],
    commonSpecs: {},
  },
  'Antiasit': {
    slug: 'antiasit',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-render.png',
    products: [
      {
        id: 0,
        name: 'Antiasit Bej 33x33',
        color: 'Beige',
        size: '33x33',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-beige.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 1,
        name: 'Antiasit Beyaz 33x33',
        color: 'Blanc',
        size: '33x33',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-blanc.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 2,
        name: 'Antiasit Gri 33x33',
        color: 'Gris',
        size: '33x33',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antiasit/antiasit-gris.png',
        faces: [''],
        specifications: {},
      },
    ],
    documents: [],
    commonSpecs: {},
  },
  'Antibes': {
    slug: 'antibes',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antibes/antibes.jpg',
    products: [
      {
        id: 0,
        name: 'Antibes 30x60',
        color: '',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antibes/antibes.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/antibeshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Anticatto': {
    slug: 'anticatto',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/anticatto/anticatto-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/anticatto/anticatto-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/anticatto/anticatto-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/anticatto/anticatto-render.png',
    products: [
      {
        id: 0,
        name: 'Anticatto Bianco 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/anticatto/anticatto-bianco.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Anticatto Misto 60x60',
        color: 'Mixte',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/anticatto/anticatto-misto.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Antique Carrara': {
    slug: 'antique-carrara',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-render.png',
    products: [
      {
        id: 0,
        name: 'Antique Carrara Dekor 40x120',
        color: '',
        size: '40x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-2.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Antique Carrara Polygon Dekor 40x120',
        color: '',
        size: '40x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-3.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Antique Carrara Parlak 60x60',
        color: '',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-parlak-60x60.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Antique Carrara Dekofon 40x120',
        color: '',
        size: '40x120',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-dekofon.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 4,
        name: 'Antique Carrara Dekofon 40x120',
        color: '',
        size: '40x120',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-dekor.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 5,
        name: 'Antique Carrara Dekofon 40x120',
        color: '',
        size: '40x120',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-polygon-dekor.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 6,
        name: 'Antique Carrara 40x120',
        color: '',
        size: '40x120',
        surface: 'Fon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-2.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 7,
        name: 'Antique Carrara 40x120',
        color: '',
        size: '40x120',
        surface: 'Fon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-3.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 8,
        name: 'Antique Carrara 40x120',
        color: '',
        size: '40x120',
        surface: 'Fon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-2.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 9,
        name: 'Antique Carrara Parlak 61x61',
        color: 'Parlak',
        size: '61x61',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/antique-carrara/antique-carrara-parlak-61x61.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Aqua Marin': {
    slug: 'aqua-marin',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aqua-marin/aqua-marin-render.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-render-2.png',
    products: [
      {
        id: 0,
        name: '40X40 ARCH GREY',
        color: 'Gris',
        size: '40x40',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-acik-gris-30x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'ARCH A.GRI 40X40 MAT',
        color: 'Gris anthracite',
        size: '40x40',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-acik-gris-60x120.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'ARCH ACIK GRI 30X60 PRLK',
        color: 'Gris clair',
        size: '30x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris-30x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Arch Açık Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris-dekofon.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 4,
        name: 'Arch Açık Gri Parlak 60x60',
        color: 'Gris',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris-parlak.png',
        faces: [
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 5,
        name: 'ARCH GREY  FON 30X60 PRLK',
        color: 'Gris',
        size: '30x60',
        surface: 'Fon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 6,
        name: 'Arch Gri Dekofon 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-mix-dekor.png',
        faces: [
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 7,
        name: 'Arch Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-acik-gris-60x120.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 8,
        name: 'Arch Gri Parlak 60x60',
        color: 'Gris',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-acik-gris-30x60.png',
        faces: [
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 9,
        name: 'ARCHMixDekor',
        color: 'Mix',
        size: '',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-mix-dekor.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 10,
        name: 'Aqua Marin 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aqua-marin/aquamarin.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Arcides': {
    slug: 'arcides',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-render-2.png',
    products: [
      {
        id: 0,
        name: 'Arcides Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Arcides Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Arcides Bone 60x120',
        color: 'Beige',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-bone.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Arcides Bone 60x60',
        color: 'Beige',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-latte-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 4,
        name: 'Arcides Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-gris-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 5,
        name: 'Arcides Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-gris.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 6,
        name: 'ARCIDES LATTE-30X60',
        color: 'Latte',
        size: '30x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-latte.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 7,
        name: 'Arcides Latte 60x120',
        color: 'Latte',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke-60x60.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 8,
        name: 'Arcides Latte 60x60',
        color: 'Latte',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 9,
        name: 'Arcides Smoke 30x60',
        color: 'Fumé',
        size: '30x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 10,
        name: 'Arcides Smoke 60x120',
        color: 'Fumé',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke-60x60.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 11,
        name: 'Arcides Smoke 60x60',
        color: 'Fumé',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke-60x60.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 12,
        name: 'ARCIDES VIZON 60X120',
        color: 'Vison',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite-60x60.png',
        faces: [
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 13,
        name: 'Arcides Antrasit 61x61',
        color: 'Anthracite',
        size: '61x61',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite-60x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 14,
        name: 'Arcides Bone 61x61',
        color: 'Bone',
        size: '61x61',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-bone.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 15,
        name: 'Arcides Gris 61x61',
        color: 'Gris',
        size: '61x61',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-gris-60x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 16,
        name: 'Arcides Latte 61x61',
        color: 'Latte',
        size: '61x61',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-latte-60x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 17,
        name: 'Arcides Smoke 61x61',
        color: 'Smoke',
        size: '61x61',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke-60x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 18,
        name: 'Arcides Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 19,
        name: 'Arcides Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-bone.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 20,
        name: 'Arcides Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-gris.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 21,
        name: 'Arcides Latte 60x120',
        color: 'Latte',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-latte.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 22,
        name: 'Arcides Smoke 60x120',
        color: 'Smoke',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 23,
        name: 'Arcides Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 24,
        name: 'Arcides Bone 60x60',
        color: 'Beige',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-latte-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 25,
        name: 'Arcides Latte 60x60',
        color: 'Latte',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-latte-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 26,
        name: 'Arcides Smoke 60x60',
        color: 'Fumé',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-smoke-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 27,
        name: 'Arcides Antrasit 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 28,
        name: 'Arcides Bone 30x60',
        color: 'Beige',
        size: '30x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 29,
        name: 'Arcides Grey 30x60',
        color: 'Grey',
        size: '30x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcides/arcides-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Arcos': {
    slug: 'arcos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcos/arcos-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcos/arcos-render.png',
    products: [
      {
        id: 0,
        name: 'Arcos Mocha 60x120',
        color: 'Moka',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcos/arcos-mocha.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Arcos Silver 60x120',
        color: 'Argent',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcos/arcos-silver.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Arcos Smoke 60x120',
        color: 'Fumé',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arcos/arcos-smoke.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },

  'Arch': {
    slug: 'arch',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-render.png',
    products: [
      {
        id: 0,
        name: 'Arch Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris-30x60.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 1,
        name: 'Arch Açık Gri 30x60',
        color: 'Gris Clair',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-acik-gris-30x60.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 2,
        name: 'Arch Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 3,
        name: 'Arch Gris Brillant',
        color: 'Gris',
        size: '',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris-parlak.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 4,
        name: 'Arch Décor',
        color: 'Mix',
        size: '',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-mix-dekor.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 5,
        name: 'Arch Gris Décor',
        color: 'Gris',
        size: '',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-gris-dekofon.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 6,
        name: 'Arch Açık Gri Mat 50x50',
        color: 'Açık Gri',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-acik-gris-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Arch Mix Dekor 30x60',
        color: 'Mix',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arch/arch-mix-dekor.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [],
    commonSpecs: {},
  },
  'Aren': {
    slug: 'aren',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aren/aren-beige.png',
    products: [
      {
        id: 0,
        name: 'Aren White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aren/aren-white.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Aren Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aren/aren-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Aren Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aren/aren-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/arenhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Aristo': {
    slug: 'aristo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-render-2.png',
    products: [
      {
        id: 0,
        name: 'Aristo Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-acik-gris.png',
        faces: [
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Aristo Açık Gri 80x80',
        color: 'Gris',
        size: '80x80',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-acik-gris.png',
        faces: [
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 3,
        name: 'Aristo Vizon 80x80',
        color: 'Vison',
        size: '80x80',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-vizon.png',
        faces: [
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 4,
        name: 'Aristo Vizon 60x120',
        color: 'Vison',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/aristo/aristo-vizon-60x60.png',
        faces: [
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Arno': {
    slug: 'arno',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arno/arno-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arno/arno-render.png',
    products: [
      {
        id: 0,
        name: 'Arno 50x50',
        color: '',
        size: '50x50',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/arno/arno.png',
        faces: [
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },
  'Artanes Oxide': {
    slug: 'artanes-oxide',
    categories: ['Jardin'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/artanes-oxide/artanes-oxide-render.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-render-2.png',
    products: [
      {
        id: 0,
        name: 'Assos Dekofon 30x90',
        color: '',
        size: '30x90',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-dekofon-30x90.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 1,
        name: 'Assos 30x90',
        color: '',
        size: '30x90',
        surface: 'Fon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-30x90.png',
        faces: [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ],
        specifications: {
          // À remplir depuis le PDF
        },
      },
      {
        id: 2,
        name: 'Artanes Oxide 60x120',
        color: 'Oxide',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/artanes-oxide/artane-oxide.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      { name: 'Fiche Produit', file: '', type: 'RAR' },
      { name: 'Renders', file: '', type: 'RAR' },
      { name: 'Textures', file: '', type: 'RAR' }
    ],
    commonSpecs: {
      // À remplir depuis le PDF
    },
  },

  'Assos': {
    slug: 'assos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-render.png',
    products: [
      {
        id: 0,
        name: 'Assos Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-beige-60x120.jpg',
        faces: [''],
        specifications: {},
      },
      {
        id: 1,
        name: 'Assos Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-gris-60x120.jpg',
        faces: [''],
        specifications: {},
      },
      {
        id: 2,
        name: 'Assos Noche 60x120',
        color: 'Noche',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-noche-60x120.jpg',
        faces: [''],
        specifications: {},
      },
      {
        id: 3,
        name: 'Assos Silver 60x120',
        color: 'Argent',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-silver-60x120.jpg',
        faces: [''],
        specifications: {},
      },
      {
        id: 4,
        name: 'Assos Décor 30x90',
        color: 'Mix',
        size: '30x90',
        surface: 'Dekofon',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-dekofon-30x90.png',
        faces: [''],
        specifications: {},
      },
      {
        id: 5,
        name: 'Assos 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 6,
        name: 'Assos Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-beige-60x120.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 7,
        name: 'Assos Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-gris-60x120.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 8,
        name: 'Assos Noche 60x120',
        color: 'Noche',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-noche-60x120.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 9,
        name: 'Assos Silver 60x120',
        color: 'Silver',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/assos/assos-silver-60x120.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [],
    commonSpecs: {},
  },
  'Astoria': {
    slug: 'astoria',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
    products: [
      {
        id: 0,
        name: 'Astoria Crema 30x90',
        color: 'Crema',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Astoria Crema Dekofon 30x90',
        color: 'Crema Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-3.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Astoria Crema Dekor 30x90',
        color: 'Crema Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Astoria Turkuaz 30x90',
        color: 'Turkuaz',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Astoria Turkuaz Dekofon 30x90',
        color: 'Turkuaz Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Astoria Kahve 30x90',
        color: 'Café',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Astoria Kahve Dekofon 30x90',
        color: 'Café Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Astoria Gri 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-gris-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Astoria Gri Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-crema-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Astoria Gri Dekor 30x90',
        color: 'Gris Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-gris-dekor.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Astoria Crema 60x60',
        color: 'Crema',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/astoria/astoria-2.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/astoriahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Atelier': {
    slug: 'atelier',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-render-2.png',
    products: [
      {
        id: 0,
        name: 'Atelier Pearl 15x60',
        color: 'Perle',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-ash.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Atelier Teak 15x60',
        color: 'Teak',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-teak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Atelier Walnut 15x60',
        color: 'Walnut',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-walnut.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Atelier Ash 15x60',
        color: 'Ash',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atelier/atelier-pearl.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/atelierhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Atlantik': {
    slug: 'atlantik',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atlantik/atlantik-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atlantik/atlantik-render.png',
    products: [
      {
        id: 0,
        name: 'Atlantik 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/atlantik/atlantik.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/atlantikhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Avanos': {
    slug: 'avanos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-render-2.png',
    products: [
      {
        id: 0,
        name: 'Avanos Beige 40x120',
        color: 'Beige',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Avanos 40x120',
        color: '',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Avanos Dekofon 40x120',
        color: 'Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Avanos 60x60',
        color: '',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/avanos/avanos.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/avanoshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Belgium Stone': {
    slug: 'belgium-stone',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-render-2.png',
    products: [
      {
        id: 0,
        name: 'Belgium Stone Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-light-gris-60x60.png',
        faces: [],
        specifications: {}
      },
      {
        id: 1,
        name: 'Belgium Stone Light Grey 30x60',
        color: 'Gris Clair',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-gris-30x60.png',
        faces: [],
        specifications: {}
      },
      {
        id: 2,
        name: 'Belgium Stone Grey 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-light-gris-30x60.png',
        faces: [],
        specifications: {}
      },
      {
        id: 3,
        name: 'Belgium Stone Black 30x60',
        color: 'Noir',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-black-30x60.png',
        faces: [],
        specifications: {}
      },
      {
        id: 4,
        name: 'Belgium Stone Grey Mozaik 30x48.6',
        color: 'Gris',
        size: '30x48.6',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-gris-mozaik-30x48,6.png',
        faces: [],
        specifications: {}
      },
      {
        id: 5,
        name: 'Belgium Stone Black Mozaik 30x48.6',
        color: 'Noir',
        size: '30x48.6',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-black-mozaik-30x48,6.png',
        faces: [],
        specifications: {}
      },
      {
        id: 7,
        name: 'Belgium Stone Grey Mozaik 33x33',
        color: 'Gris',
        size: '33x33',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-gris-mozaik.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Belgium Stone Black Mozaik 33x33',
        color: 'Noir Mozaik',
        size: '33x33',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-black-mozaik.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Belgium Stone Grey Mozaik 30.5x30.5',
        color: 'Gris',
        size: '30.5x30.5',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/beligum-stone-gris-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Belgium Stone Black Mozaik 30.5x30.5',
        color: 'Noir Mozaik',
        size: '30.5x30.5',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/belgium-stone-black-mozaik-30x48,6.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Belgium Stone Light Grey 60x60',
        color: 'Light Grey',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belgium-stone/beligum-stone-gris-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/belgium-stonehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Belita': {
    slug: 'belita',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belita/belita-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belita/belita-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belita/belita-render-2.png',
    products: [
      {
        id: 0,
        name: 'Belita 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/belita/Belita.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/belitahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Bellatrix': {
    slug: 'bellatrix',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bellatrix/bellatrix-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bellatrix/bellatrix-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bellatrix/bellatrix-render.png',
    products: [
      {
        id: 0,
        name: 'Bellatrix 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bellatrix/Bellatrix.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/bellatrixhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Bengal': {
    slug: 'bengal',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-render-2.png',
    products: [
      {
        id: 0,
        name: 'Bengal Perla 60x120',
        color: 'Perla',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-perla-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Bengal Oxido 60x120',
        color: 'Oxido',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-oxido-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Bengal Perla 60x60',
        color: 'Perla',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-perla-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Bengal Oxido 60x60',
        color: 'Oxido',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-oxido-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Bengal Perla 30x90',
        color: 'Perla',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-perla-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Bengal Oxido 30x90',
        color: 'Oxido',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-oxido-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Bengal Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-dekofon-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Bengal Dekor 30x90',
        color: 'Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bengal/bengal-dekor-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/bengalhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Beton': {
    slug: 'beton',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-render-2.png',
    products: [
      {
        id: 0,
        name: 'Beton Bianco 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-bianco-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Beton Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-gris-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Beton Bianco 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-bianco-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Beton Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-gris-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Beton Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-antrasit-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Beton Bianco 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-bianco-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Beton Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-gris-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Beton Antrasit 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/beton/beton-antrasit-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/betonhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Black Star': {
    slug: 'black-star',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/black-star/black-star-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/black-star/black-star-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/black-star/black-star-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/black-star/black-star-render-2.png',
    products: [
      {
        id: 0,
        name: 'Black Star 60x120',
        color: '',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/black-star/black-star.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/black-starhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Boho': {
    slug: 'boho',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-render-2.png',
    products: [
      {
        id: 0,
        name: 'Boho Gris Clair 120x120',
        color: 'Gris Clair',
        size: '120x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-light-grey-120x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Boho Light Grey 60x120',
        color: 'Gris Clair',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-dark-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Boho Dark Grey 60x120',
        color: 'Gris Foncé',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-light-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Boho Light Grey 20x120',
        color: 'Gris Clair',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/boho/boho-light-grey-120x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/bohohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Bona Dea': {
    slug: 'bona-dea',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-render-2.png',
    products: [
      {
        id: 0,
        name: 'Bona Dea Crema 120x120',
        color: 'Crema',
        size: '120x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Bona Dea Gris Clair 120x120',
        color: 'Gris Clair',
        size: '120x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Bona Dea Bianco 100x100',
        color: 'Blanc',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-bianco-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Bona Dea Crema 100x100',
        color: 'Crema',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Bona Dea Beige 100x100',
        color: 'Beige',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Bona Dea Light Grey 100x100',
        color: 'Gris Clair',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Bona Dea Dark Grey 100x100',
        color: 'D. Gris',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Bona Dea Bianco 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Bona Dea Crema 60x120',
        color: 'Crema',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-ivory-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Bona Dea Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Bona Dea Light Grey 60x120',
        color: 'Gris Clair',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Bona Dea Dark Grey 60x120',
        color: 'D. Gris',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Bona Dea Bianco 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-bianco-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Bona Dea Bianco 61x61',
        color: 'Blanc',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-bianco-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 14,
        name: 'Bona Dea Ivory 61x61',
        color: 'Ivoire',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-ivory-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 15,
        name: 'Bona Dea Ivory Dekofon 61x61',
        color: 'Ivoire Dekofon',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-ivory-dekofon-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 16,
        name: 'Bona Dea Crema 60x60',
        color: 'Crema',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 17,
        name: 'Bona Dea Crema 61x61',
        color: 'Crema',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 18,
        name: 'Bona Dea Beige 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 19,
        name: 'Bona Dea Beige 61x61',
        color: 'Beige',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 20,
        name: 'Bona Dea Light Grey 60x60',
        color: 'Gris Clair',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 21,
        name: 'Bona Dea Light Grey Dekofon 60x60',
        color: 'L. Gris Dekofon',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-dekofon-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 22,
        name: 'Bona Dea Light Grey 61x61',
        color: 'Gris Clair',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 23,
        name: 'Bona Dea Light Grey Dekofon 61x61',
        color: 'L. Gris Dekofon',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-dekofon-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 24,
        name: 'Bona Dea Dark Grey 60x60',
        color: 'D. Gris',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 25,
        name: 'Bona Dea Dark Grey Dekofon 60x60',
        color: 'D. Gris Dekofon',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-dekofon-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 26,
        name: 'Bona Dea Dark Grey 61x61',
        color: 'D. Gris',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 27,
        name: 'Bona Dea Dark Grey Dekofon 61x61',
        color: 'D. Gris Dekofon',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-dekofon-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 28,
        name: 'Bona Dea Crema 30x60',
        color: 'Crema',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 29,
        name: 'Bona Dea Beige 30x60',
        color: 'Beige',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 30,
        name: 'Bona Dea Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-beige-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 31,
        name: 'Bona Dea Bianco 60x120',
        color: 'Bianco',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-bianco-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 32,
        name: 'Bona Dea Crema 60x120',
        color: 'Crema',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-30x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 33,
        name: 'Bona Dea Dark Grey 60x120',
        color: 'Dark Grey',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 34,
        name: 'Bona Dea Light Grey 60x120',
        color: 'Light Grey',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 35,
        name: 'Bona Dea Crema 60x60',
        color: 'Crema',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 36,
        name: 'Bona Dea Dark Grey 60x60',
        color: 'D. Gris',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 37,
        name: 'Bona Dea Dark Grey Dekofon 60x60',
        color: 'D. Gris Dekofon',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-dark-grey-dekofon-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 38,
        name: 'Bona Dea Light Grey Dekofon 60x60',
        color: 'L. Gris Dekofon',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-dekofon-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 39,
        name: 'Bona Dea Crema 20x120',
        color: 'Crema',
        size: '20x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-crema-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 40,
        name: 'Bona Dea Light Grey 20x120',
        color: 'L. Gris',
        size: '20x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bona-dea/bona-dea-light-grey-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/bona-deahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Bond': {
    slug: 'bond',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-render-2.png',
    products: [
      {
        id: 0,
        name: 'Bond Beige 40x120',
        color: 'Beige',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-beige-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Bond Wood Dekofon 40x120',
        color: 'Wood Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-wood-dekofon-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Bond Grey 40x120',
        color: 'Gris',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-grey-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Bond Bazalt Dekofon 40x120',
        color: 'Bazalt Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-bazalt-dekofon-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Bond Beige 30x90',
        color: 'Beige',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-beige-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Bond Wood Dekofon 30x90',
        color: 'Wood Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-wood-dekofon-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Bond Bazalt Dekofon 30x90',
        color: 'Bazalt Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-bazalt-dekofon-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Bond Beige 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bond/bond-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/bondhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Bosco': {
    slug: 'bosco',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bosco/bosco-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bosco/bosco-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bosco/bosco-render-2.png',
    products: [
      {
        id: 0,
        name: 'Bosco 20x120',
        color: '',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bosco/Bosco.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/boscohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Brano': {
    slug: 'brano',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-render-2.png',
    products: [
      {
        id: 0,
        name: 'Brano Mat Beyaz 40x120',
        color: 'Mat Blanc',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-mat-beyaz-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Brano Mat Beyaz 30x90',
        color: 'Mat Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-mat-beyaz-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Brano Mat Beyaz 30x60',
        color: 'Mat Blanc',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-mat-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Brano Mat Pergamon 30x60',
        color: 'Mat Pergamon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-mat-pergamon-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Brano Mat Beyaz 30x40',
        color: 'Mat Blanc',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brano/brano-mat-beyaz-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/branohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Bravas': {
    slug: 'bravas',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bravas/bravas-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bravas/bravas-render.png',
    products: [
      {
        id: 0,
        name: 'Bravas Gris 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/bravas/bravas-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/bravashttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Brillo': {
    slug: 'brillo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-render-2.png',
    products: [
      {
        id: 0,
        name: 'Brillo Parlak Beyaz 30x90',
        color: 'Brillant Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-parlak-beyaz-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Brillo Parlak Beyaz 30x60',
        color: 'Brillant Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-parlak-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Brillo Parlak Pergamon 30x60',
        color: 'Brillant Pergamon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-parlak-pergamon-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Brillo Parlak Beyaz 30x40',
        color: 'Brillant Blanc',
        size: '30x40',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/brillo/brillo-parlak-beyaz-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/brillohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Buxy': {
    slug: 'buxy',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/buxy/buxy-antrasit.png',
    products: [
      {
        id: 0,
        name: 'Buxy Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/buxy/buxy-gris-1.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Buxy Antrasit 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/buxy/buxy-antrasit.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/buxyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Calacatta Marmi': {
    slug: 'calacatta-marmi',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-render-3.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-render-2.png',
    products: [
      {
        id: 0,
        name: 'Calacatta Marmi Parlak 30x90',
        color: 'Glossy',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-parlak-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Calacatta Marmi Parlak Dekofon 30x90',
        color: 'Glossy Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-mat-dekofon-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Calacatta Marmi Parlak Dekor 30x90',
        color: 'Glossy Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-parlak-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Calacatta Marmi Mat 30x90',
        color: 'Mat',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-mat-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Calacatta Marmi Mat Dekofon 30x90',
        color: 'Mat Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-mat-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Calacatta Marmi Parlak 30x60',
        color: 'Glossy',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmi-parlak-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Calacatta Marmi Mat 30x60',
        color: 'Mat',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calcatta-marmi-parlak-dekor.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Calacatta Marmi 60x60',
        color: '',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/calacatta-marmi/calacatta-marmı-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/calacatta-marmihttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Camouflage': {
    slug: 'camouflage',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/camouflage/camouflage-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/camouflage/camouflage-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/camouflage/camouflage-render-2.png',
    products: [
      {
        id: 0,
        name: 'Camouflage 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/camouflage/camouflage-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/camouflagehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Capella': {
    slug: 'capella',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/capella/capella-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/capella/capella-render-2.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/capella/capella-render-2.png',
    products: [
      {
        id: 0,
        name: 'Capella 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/capella/capella-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/capellahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Cappadocia': {
    slug: 'cappadocia',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-render-2.png',
    products: [
      {
        id: 0,
        name: 'Cappadocia Sand 30x90',
        color: 'Sable',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-sand-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Cappadocia Sand Decofon 30x90',
        color: 'Sable Décofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/capadoccia-sand-dekofon-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Cappadocia Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-grey-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Cappadocia Grey Decofon 30x90',
        color: 'Gris Décofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-grey-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Cappadocia Sand 60x60',
        color: 'Sable',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-sand-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Cappadocia Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cappadocia/cappadocia-grey-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/cappadociahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Carbon': {
    slug: 'carbon',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carbon/carbon-render.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carbon/carbon-render.png',
    products: [
      {
        id: 0,
        name: 'Carbon Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carbon/carbon-grey-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Carbon Anthracite 60x120',
        color: 'Antracit',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carbon/carbon-anthracite-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/carbonhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Casta': {
    slug: 'casta',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-render-2.png',
    products: [
      {
        id: 0,
        name: 'Casta Beige 30x90',
        color: 'Beige',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-beige-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Casta Beige Dekofon 30x90',
        color: 'Beige Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-beige-matis-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Casta Beige Matis Dekofon 30x90',
        color: 'Beige Matis Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-grey-matis-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Casta Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-grey-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Casta Grey Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-grey-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Casta Grey Matis Dekofon 30x90',
        color: 'Gris Matis Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/casta/casta-beige-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/castahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Catalpa': {
    slug: 'catalpa',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/catalpa/catalpa-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/catalpa/catalpa-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/catalpa/catalpa-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/catalpa/catalpa-render.png',
    products: [
      {
        id: 0,
        name: 'Catalpa 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/catalpa/catalpa-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/catalpahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Chakra': {
    slug: 'chakra',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chakra/chakra-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chakra/chakra-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chakra/chakra-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chakra/chakra-render-2.png',
    products: [
      {
        id: 0,
        name: 'Chakra 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chakra/Chakra.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Chakra Dekofon 60x120',
        color: 'Dekofon',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chakra/chakre-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/chakrahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Charlotte': {
    slug: 'charlotte',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charlotte/charlotte-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charlotte/charlotte-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charlotte/charlotte-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charlotte/charlotte-render.png',
    products: [
      {
        id: 0,
        name: 'Charlotte 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charlotte/Charlotte.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/charlottehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Charm': {
    slug: 'charm',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charm/charm-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charm/charm-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charm/charm-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charm/charm-render-2.png',
    products: [
      {
        id: 0,
        name: 'Charm Rust 60x120',
        color: 'Rouille',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charm/charm-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Charm Blue 60x120',
        color: 'Bleu',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/charm/charm-rust.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/charmhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Chester': {
    slug: 'chester',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chester/chester-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chester/chester-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chester/chester-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chester/chester-render-2.png',
    products: [
      {
        id: 0,
        name: 'Chester Bej 61x61',
        color: 'Beige',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chester/chester-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Chester Gri 61x61',
        color: 'Gris',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/chester/chester-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/chesterhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Cleopatra': {
    slug: 'cleopatra',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cleopatra/cleopatra-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cleopatra/cleopatra-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cleopatra/cleopatra-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cleopatra/cleopatra-render.png',
    products: [
      {
        id: 0,
        name: 'Cleopatra 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cleopatra/cleopatra-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Cleopatra 30x60',
        color: '',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/cleopatra/cleopatra-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/cleopatrahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Clio': {
    slug: 'clio',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/clio/clio-render.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/clio/clio-render-2.jpg',
    ],
    products: [
      {
        id: 0,
        name: 'Clio Gris 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/clio/clio-grey.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Clio Argent 100x100',
        color: 'Argent',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/clio/clio-silver.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/cliohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Concept': {
    slug: 'concept',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-render.png',
    products: [
      {
        id: 0,
        name: 'Concept Beyaz 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beyaz-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Concept Bej 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beige-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Concept Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Concept Beyaz 60x120',
        color: 'Taupe',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-acik-gris-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Concept Açık Gri 60x120',
        color: 'Gris Clairs',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-gris-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Concept Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-acik-gris-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Concept Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-antrasit-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Concept Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Concept Bej 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Concept Vizon 60x60',
        color: 'Vizon',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-60x60 (2).png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Concept Vizon 60x60',
        color: 'Taupe',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-acik-gris-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Concept Açık Gri 60x60',
        color: 'Gris Clairs',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-gris-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Concept Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-antrasit-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Concept Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-antrasit-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 14,
        name: 'Concept Siyah 60x60',
        color: 'Noir',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-noir-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 15,
        name: 'Concept Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 16,
        name: 'Concept Bej 30x60',
        color: 'Beige',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beige-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 17,
        name: 'Concept Vizon 30x60',
        color: 'Vizon',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-30x60 (2).png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 18,
        name: 'Concept Taupe 30x60',
        color: 'Taupe',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-gris-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 19,
        name: 'Concept Açık Gri 30x60',
        color: 'Gris Clairs',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-30x60 (3).png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 20,
        name: 'Concept Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 21,
        name: 'Concept Antrasit 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-siyah-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 22,
        name: 'Concept Siyah 30x60',
        color: 'Noir',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 23,
        name: 'Concept Açık Gri 60x120',
        color: 'Açık Gri',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-acik-gris-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 24,
        name: 'Concept Antrasit 60x120',
        color: 'Antrasit',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-antrasit-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 25,
        name: 'Concept Bej 60x120',
        color: 'Bej',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beige-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 26,
        name: 'Concept Bej 60x120',
        color: 'Bej',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beige-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 27,
        name: 'Concept Beyaz 60x120',
        color: 'Beyaz',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beyaz-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 28,
        name: 'Concept Gri 60x120',
        color: 'Gri',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-gris-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 29,
        name: 'Concept Gri 60x120',
        color: 'Gri',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-gris-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 30,
        name: 'Concept Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 31,
        name: 'Concept Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 32,
        name: 'Concept Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-vizon-60x120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 33,
        name: 'Concept Bej 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-beige-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 34,
        name: 'Concept Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/concept/concept-gris-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/concepthttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Coper': {
    slug: 'coper',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/coper/coper-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/coper/coper-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/coper/coper-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/coper/coper-render.png',
    products: [
      {
        id: 0,
        name: 'Coper Moss 60x120',
        color: 'Moss',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/coper/coper-moss.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Coper Sky 60x120',
        color: 'Sky',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/coper/coper-sky.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/coperhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Country': {
    slug: 'country',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/country/country-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/country/country-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/country/country-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/country/country-render.png',
    products: [
      {
        id: 0,
        name: 'Country Walnut 20x120',
        color: 'Walnut',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/country/country-walnut.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Country Venge 20x120',
        color: 'Venge',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/country/country-venge-.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/countryhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Crag': {
    slug: 'crag',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-render.png',
    products: [
      {
        id: 0,
        name: 'Crag White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-white.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Crag Ivory 60x120',
        color: 'Ivoire',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-ivory.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Crag Cotto 60x120',
        color: 'Cotto',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-cotto.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Crag Mocha 60x120',
        color: 'Moka',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-mocha.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Crag Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Crag Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crag/crag-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/craghttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Crotone': {
    slug: 'crotone',
    categories: ['Jardin'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crotone/crotone-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crotone/crotone-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crotone/crotone-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crotone/crotone-render.png',
    products: [
      {
        id: 0,
        name: 'Crotone 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crotone/crotone-60x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Crotone 60x60',
        color: '',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/crotone/crotone-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/crotonehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Darkness': {
    slug: 'darkness',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/darkness/darkness-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/darkness/darkness-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/darkness/darkness-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/darkness/darkness-render.png',
    products: [
      {
        id: 0,
        name: 'Darkness 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/darkness/Darkness.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/darknesshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Delbin': {
    slug: 'delbin',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-render.png',
    products: [
      {
        id: 0,
        name: 'Delbin Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-beyaz.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Delbin Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Delbin Füme 30x60',
        color: 'Fumée',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/delbin/delbin-fume.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/delbinhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Destiny': {
    slug: 'destiny',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-render.png',
    products: [
      {
        id: 0,
        name: 'Destiny Parlak Beyaz 60x60',
        color: 'Brillant Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-parlak-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Destiny Mat Beyaz 60x60',
        color: 'Mat Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-mat-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Destiny Parlak Beyaz 61x61',
        color: 'Brillant Blanc',
        size: '61x61',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-parlak-beyaz-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Destiny Parlak Beyaz 60x60',
        color: 'Brillant Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/destiny/destiny-parlak-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/destinyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Dina': {
    slug: 'dina',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dina/dina-render.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dina/dina-render-2.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dina/dina-render-3.jpg',
    ],
    products: [
      {
        id: 0,
        name: 'Dina 30x60',
        color: '',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dina/dina.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/dinahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Diva': {
    slug: 'diva',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/diva/diva-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/diva/diva-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/diva/diva-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/diva/diva-render.png',
    products: [
      {
        id: 0,
        name: 'Diva 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/diva/diva-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/divahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Dora': {
    slug: 'dora',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dora/dora-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dora/dora-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dora/dora-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dora/dora-render.png',
    products: [
      {
        id: 0,
        name: 'Dora Parlak 60x60',
        color: 'Brillant',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dora/dora-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/dorahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Dove': {
    slug: 'dove',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-render.png',
    products: [
      {
        id: 0,
        name: 'Dove Mat Beyaz 30x90',
        color: 'Mat Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-mat-beyaz-30x90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Dove Parlak Beyaz 30x60',
        color: 'Brillant Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-parlak-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Dove Mat Beyaz 30x60',
        color: 'Mat Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-mat-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Dove Parlak Beyaz 20x40',
        color: 'Brillant Blanc',
        size: '20x40',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-mat-beyaz-20x40.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Dove Mat Beyaz 20x40',
        color: 'Mat Blanc',
        size: '20x40',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/dove/dove-parlak-20x40.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/dovehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Elan': {
    slug: 'elan',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-render.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-render.jpg',
    products: [
      {
        id: 0,
        name: 'Elan Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Elan Brown 60x120',
        color: 'Brun',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-brown.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Elan Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Elan Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elan/elan-antrasit.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/elanhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Eleganza': {
    slug: 'eleganza',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-render.png',
    products: [
      {
        id: 0,
        name: 'Eleganza Maple 20x120',
        color: 'Maple',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-maple.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Eleganza Walnut 20x120',
        color: 'Walnut',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-walnut.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Eleganza Oak 20x120',
        color: 'Oak',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/eleganza/eleganza-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/eleganzahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Elitra': {
    slug: 'elitra',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elitra/elitra-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elitra/elitra-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elitra/elitra-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elitra/elitra-render.png',
    products: [
      {
        id: 0,
        name: 'Elitra 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elitra/elitra-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/elitrahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Elora': {
    slug: 'elora',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elora/elora-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elora/elora-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elora/elora-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elora/elora-render.png',
    products: [
      {
        id: 0,
        name: 'Elora 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/elora/elora.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/elorahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Enzo': {
    slug: 'enzo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-render.png',
    products: [
      {
        id: 0,
        name: 'Enzo Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Enzo Beyaz Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-beyaz.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Enzo Gri 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Enzo Antrasit 30x90',
        color: 'Anthracite',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Enzo Mix Dekofon 30x90',
        color: 'Mix Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-mix-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Enzo Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/enzo/enzo-white-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/enzohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Epona': {
    slug: 'epona',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/epona/epona-render.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/epona/epona-render-2.jpg',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/epona/epona-render-3.jpg',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/epona/epona-render.jpg',
    products: [
      {
        id: 0,
        name: 'Epona 30x60',
        color: '',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/epona/epona.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/eponahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Estel': {
    slug: 'estel',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-render.png',
    products: [
      {
        id: 0,
        name: 'Estel Latte 30x90',
        color: 'Latte',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-latte.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Estel Ruby 30x90',
        color: 'Ruby',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-ruby.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Estel Olive 30x90',
        color: 'Olive',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-olive.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Estel Azul 30x90',
        color: 'Azul',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-azul.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Estel Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/estel/estel-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/estelhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Europe': {
    slug: 'europe',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-render.png',
    products: [
      {
        id: 0,
        name: 'Europe White 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-white-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Europe Beige 30x60',
        color: 'Beige',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/euope-beige-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Europe Grey 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-grey-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Europe Black 30x60',
        color: 'Noir',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-black-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Europe White 30x40',
        color: 'Blanc',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-white-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Europe Beige 30x40',
        color: 'Beige',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-black-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Europe Grey 30x40',
        color: 'Gris',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-grey-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Europe Greige 30x40',
        color: 'Greige',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/europe-greige-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Europe Black 30x40',
        color: 'Noir',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/europe/eurpo-beige-30x40.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/europehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Everest': {
    slug: 'everest',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    renders: [
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/everest/everest-render.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/everest/everest-render-2.png',
      'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/everest/everest-render-3.png',
    ],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/everest/everest-render.png',
    products: [
      {
        id: 0,
        name: 'Everest 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/everest/Everest.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/everesthttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Fair': {
    slug: 'fair',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-gris-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Fair Gris 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-nero-dekor.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Fair Gris Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-gris-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Fair Gris Dekor 30x90',
        color: 'Gris Dekor',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-nero-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Fair Nero 30x90',
        color: 'Nero',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-gris-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Fair Nero Dekofon 30x90',
        color: 'Nero Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-gris-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Fair Nero Dekor 30x90',
        color: 'Nero Dekor',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fair/fair-gris-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/fairhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Famous': {
    slug: 'famous',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/famous/famous-grey-30x90.png',
    products: [
      {
        id: 0,
        name: 'Famous Grey 40x120',
        color: 'Gris',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/famous/famous-gris-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Famous Grey Dekofon 40x120',
        color: 'Gris Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/famous/famous-gris-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Famous Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/famous/famous-gris-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Famous Grey Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/famous/famous-gris-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Famous Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/famous/famous-gris-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/famoushttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Fenix': {
    slug: 'fenix',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fenix/fenix-cherry.png',
    products: [
      {
        id: 0,
        name: 'Fenix Maple 20x120',
        color: 'Maple',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fenix/fenix-cherry.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Fenix Cherry 20x120',
        color: 'Cherry',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fenix/fenix-cherry.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Fenix Teak 20x120',
        color: 'Teak',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fenix/fenix-cherry.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Fenix Grey 20x120',
        color: 'Gris',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fenix/fenix-cherry.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/fenixhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Flevo': {
    slug: 'flevo',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/flevo/flevo-render.png',
    products: [
      {
        id: 0,
        name: 'Flevo 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/flevo/flevo-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/flevohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Fortuna': {
    slug: 'fortuna',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fortuna/fortuna-render.png',
    products: [
      {
        id: 0,
        name: 'Fortuna 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fortuna/fortuna-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/fortunahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Fraxinus': {
    slug: 'fraxinus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fraxinus/fraxinus-render.png',
    products: [
      {
        id: 0,
        name: 'Fraxinus 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fraxinus/fraxinus-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/fraxinushttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Fresno': {
    slug: 'fresno',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fresno/fresno-render.png',
    products: [
      {
        id: 0,
        name: 'Fresno 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fresno/fresno-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/fresnohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Fuji': {
    slug: 'fuji',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fuji/fuji-antracite.jpg',
    products: [
      {
        id: 0,
        name: 'Fuji Anthracite 60x120',
        color: 'Anracit',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fuji/fuji-antracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Fuji Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fuji/fuji-beige.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Fuji Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/fuji/fuji-antracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/fujihttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Gaudi': {
    slug: 'gaudi',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gaudi/gaudi-render.png',
    products: [
      {
        id: 0,
        name: 'Gaudi Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gaudi/gaudi-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/gaudihttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Gemma': {
    slug: 'gemma',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
    products: [
      {
        id: 0,
        name: 'Gemma Pearl 60x120',
        color: 'Perle',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Gemma Gold 60x120',
        color: 'Or',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Gemma Peach 60x120',
        color: 'Peach',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Gemma Sky 60x120',
        color: 'Sky',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Gemma Mint 60x120',
        color: 'Mint',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Gemma Smoke 60x120',
        color: 'Fumée',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gemma/gemma-gold.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/gemmahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Geo Wood': {
    slug: 'geo-wood',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/geo-wood/geo-wood-render.png',
    products: [
      {
        id: 0,
        name: 'Geo Wood 61x61',
        color: '',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/geo-wood/geo-wood.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/geo-woodhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Gordion': {
    slug: 'gordion',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-blanc.png',
    products: [
      {
        id: 0,
        name: 'Gordion Bone 100x100',
        color: 'Bone',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-bone-100x100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Gordion Vizon 100x100',
        color: 'Vizon',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-vizon-100x100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Gordion Mid Grey 100x100',
        color: 'Mid Gris',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-mid-gris-100x100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Gordion White 40x120',
        color: 'Blanc',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Gordion White Dekofon 40x120',
        color: 'Blanc Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Gordion Vizon 40x120',
        color: 'Taupe',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Gordion Dark Grey 40x120',
        color: 'Gris Foncé',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/gordion/gordion-dark-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/gordionhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Grace': {
    slug: 'grace',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grace/grace-bone.png',
    products: [
      {
        id: 0,
        name: 'Grace Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grace/grace-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Grace Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grace/grace-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/gracehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Grand': {
    slug: 'grand',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-ash-40x120.png',
    products: [
      {
        id: 0,
        name: 'Grand White 40x120',
        color: 'Blanc',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-ash-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Grand White Patchwork Dekofon 40x120',
        color: 'Blanc Patchwork Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-white-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Grand Ash 40x120',
        color: 'Ash',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-ash-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Grand Ash Organic Dekofon 40x120',
        color: 'Ash Organic Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-ash-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Grand White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-ash-organic-dekofon-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Grand Ash 60x60',
        color: 'Ash',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grand/grand-ash-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/grandhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Grassland': {
    slug: 'grassland',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-blue-30x60.png',
    products: [
      {
        id: 0,
        name: 'Grassland Green 60x60',
        color: 'Vert',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-blue-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Grassland Blue 60x60',
        color: 'Bleu',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-green-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Grassland Green 30x60',
        color: 'Vert',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-blue-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Grassland Blue 30x60',
        color: 'Bleu',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-blue-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Grassland Blue 60x120',
        color: 'Blue',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-blue-30x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 5,
        name: 'Grassland Green 60x120',
        color: 'Green',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/grassland/grassland-green-30x60.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/grasslandhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Greta': {
    slug: 'greta',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/greta/greta-render.png',
    products: [
      {
        id: 0,
        name: 'Greta 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/greta/greta-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/gretahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Hampton': {
    slug: 'hampton',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
    products: [
      {
        id: 0,
        name: 'Hampton Bianco 100x100',
        color: 'Blanc',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-bianco-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Hampton Latte 100x100',
        color: 'Latte',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-latte-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Hampton Anthracite 100x100',
        color: 'Anthracite',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Hampton Bianco 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Hampton Latte 60x120',
        color: 'Latte',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Hampton Grigio 60x120',
        color: 'Grisgio',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-latte-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Hampton Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Hampton Bianco 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Hampton Latte 60x60',
        color: 'Latte',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Hampton Anthracite 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Hampton Bianco 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Hampton Latte 30x60',
        color: 'Latte',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Hampton Anthracite 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-anthracite-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Hampton Açık Gri 61x61',
        color: 'Açık Gri',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-grigio-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 14,
        name: 'Hampton Açık Gri 60x60',
        color: 'Açık Gri',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hampton/hampton-latte-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/hamptonhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Harley': {
    slug: 'harley',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/harley/harley-render.jpg',
    products: [
      {
        id: 0,
        name: 'Harley 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/harley/harley-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/harleyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Helen': {
    slug: 'helen',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-bone-30X60.jpg',
    products: [
      {
        id: 0,
        name: 'Helen Bone 40x120',
        color: 'Bone',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-bone-dekofon-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Helen Taupe 40x120',
        color: 'Taupe',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-bone-dekofon-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Helen Bone Dekofon 40x120',
        color: 'Bone Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-grey-dekofon-30X60.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Helen Taupe Dekofon 40x120',
        color: 'Taupe Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-grey-dekofon-30X60.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Helen Bone 30x60',
        color: 'Bone',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-taupe-dekofon-30X60.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Helen Bone Dekofon 30x60',
        color: 'Bone Dekofon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-taupe-dekofon-30X60.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Helen Taupe 30x60',
        color: 'Taupe',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-bone-dekofon-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Helen Taupe Dekofon 30x60',
        color: 'Taupe Dekofon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-tapue-dekofon-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Helen Grey 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-bone-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Helen Grey Dekofon 30x60',
        color: 'Gris Dekofon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-tapue-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Helen Taupe 60x60',
        color: 'Taupe',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helen/helen-taupe-30X60.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/helenhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Helios': {
    slug: 'helios',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
    products: [
      {
        id: 0,
        name: 'Helios 30x90',
        color: '',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Helios Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Helios Gold 30x60',
        color: 'Or',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Helios Gold Dekofon 30x60',
        color: 'Or Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Helios Silver 30x60',
        color: 'Argent',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Helios Silver Dekofon 30x60',
        color: 'Argent Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Helios 60x60',
        color: '',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/helios/helios-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/helioshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Herringwood': {
    slug: 'herringwood',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/herringwood/herringwood-render.png',
    products: [
      {
        id: 0,
        name: 'Herringwood 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/herringwood/herringwood-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/herringwoodhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Himalaya': {
    slug: 'himalaya',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/himalaya/himalaya-render.png',
    products: [
      {
        id: 0,
        name: 'Himalaya Ice 60x120',
        color: 'Ice',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/himalaya/himalaya-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/himalayahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Hormigon Molde': {
    slug: 'hormigon-molde',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hormigon-molde/Hormigon Molde.png',
    products: [
      {
        id: 0,
        name: 'Hormigon Molde 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hormigon-molde/hormigon-molde-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/hormigon-moldehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Hypnos': {
    slug: 'hypnos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hypnos/hypnos-30X60.png',
    products: [
      {
        id: 0,
        name: 'Hypnos 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hypnos/hypnos-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Hypnos 60x60',
        color: '',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hypnos/hypnos-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Hypnos 30x60',
        color: '',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/hypnos/hypnos-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/hypnoshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Imperial': {
    slug: 'imperial',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-beyaz-60x60.png',
    products: [
      {
        id: 0,
        name: 'İmperial Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Imperial Beyaz Dekofon 30x60',
        color: 'Blanc Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'İmperial Beyaz Dekor 30x60',
        color: 'Blanc Dekor',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'İmperial Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'İmperial Gri Dekofon 30x60',
        color: 'Gris Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'İmperial Gri Hexagon Dekofon 30x60',
        color: 'Gris Hexagon Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'İmperial Gri Dekor 30x60',
        color: 'Gris Dekor',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'İmperial Beyaz 50x50',
        color: 'Blanc',
        size: '50x50',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'İmperial Gri 50x50',
        color: 'Gris',
        size: '50x50',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'İmperial Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Imperial İmperial Beyaz 61x61',
        color: 'Blanc',
        size: '61x61',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/imperial/imperial-beyaz-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/imperialhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Inca': {
    slug: 'inca',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-anthrasit-30X60.png',
    products: [
      {
        id: 0,
        name: 'Inca Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-beyaz-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Inca Vizon 30x60',
        color: 'Vizon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-anthrasit-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Inca Vizon Dekofon 30x60',
        color: 'Vizon Dekofon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-anthrasit-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Inca Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-vizon-dekofon-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Inca Antrasit 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Inca Mix Dekofon 30x60',
        color: 'Mix Dekofon',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-anthrasit-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Inca Beyaz 61x61',
        color: 'Blanc',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/inca/inca-beyaz-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/incahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Iroko': {
    slug: 'iroko',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/iroko/iroko-brown-20X120.png',
    products: [
      {
        id: 0,
        name: 'Iroko Pearl 20x120',
        color: 'Iroko Perle',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/iroko/iroko-pearl-20X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Iroko Brown 20x120',
        color: 'Iroko Brun',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/iroko/iroko-pearl-20X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Iroko Warm Grey 20x120',
        color: 'Iroko Warm Gris',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/iroko/iroko-brown-20X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/irokohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Joya': {
    slug: 'joya',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/joya/joya-30X60.png',
    products: [
      {
        id: 0,
        name: 'Joya 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/joya/joya-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Joya 30x60',
        color: '',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/joya/joya-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/joyahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Juno': {
    slug: 'juno',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Juno Diamond Dekofon 30x90',
        color: 'Diamond Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Juno Diamond 30x90',
        color: 'Diamond',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Juno Emerald Dekofon 30x90',
        color: 'Emerald Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Juno Emerald 30x90',
        color: 'Emerald',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Juno Mosaic Floral Dekofon 30x90',
        color: 'Mosaic Floral Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Juno Ruby Dekofon 30x90',
        color: 'Ruby Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Juno Ruby 30x90',
        color: 'Ruby',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Juno Sapphire Dekofon 30x90',
        color: 'Sapphire Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Juno Sapphire 30x90',
        color: 'Sapphire',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/juno/juno-diamond-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/junohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Kaleidos': {
    slug: 'kaleidos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    products: [
      {
        id: 0,
        name: 'Kaleidos Brown 80x80',
        color: 'Brun',
        size: '80x80',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kaleidos/kaleidos-brown-80X80.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Kaleidos Dark Grey 80x80',
        color: 'Gris Foncé',
        size: '80x80',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kaleidos/kaleidos-dark-grey-80X80.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Kaleidos Grey 80x80',
        color: 'Gris',
        size: '80x80',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kaleidos/kaleidos-grey-80X80.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/kaleidoshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Kallos': {
    slug: 'kallos',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kaleidos/kaleidos-brown-80X80.jpg',
    products: [
      {
        id: 0,
        name: 'Kallos Gris 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kallos/kallos-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Kallos 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kallos/Kallos.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/kalloshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Kapteyn': {
    slug: 'kapteyn',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kapteyn/kapteyn-render.png',
    products: [
      {
        id: 0,
        name: 'Kapteyn 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kapteyn/kapteyn-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/kapteynhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Karsos': {
    slug: 'karsos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/karsos/karsos.jpg',
    products: [
      {
        id: 0,
        name: 'Karsos 30x60',
        color: '',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/karsos/karsos.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/karsoshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Klein': {
    slug: 'klein',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/klein/klein-cool.png',
    products: [
      {
        id: 0,
        name: 'Klein Cool 20x120',
        color: 'Cool',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/klein/klein-cool.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Klein Fon 20x120',
        color: 'Fon',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/klein/klein-cool.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Klein Natural 20x120',
        color: 'Naturel',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/klein/klein-cool.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/kleinhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'La Vita': {
    slug: 'la-vita',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/la-vita/la-vita-render.png',
    products: [
      {
        id: 0,
        name: 'La Vita White 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/la-vita/la-vita-black-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'La Vita Black 30x90',
        color: 'Noir',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/la-vita/la-vita-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'La Vita Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/la-vita/la-vita-white-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'La Vita White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/la-vita/la-vita-black-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/la-vitahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Lamuna': {
    slug: 'lamuna',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Lamuna 60x60',
        color: '',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lamuna/lamuna.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/lamunahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Larimar Ocean': {
    slug: 'larimar-ocean',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lamuna/lamuna.jpg',
    products: [
      {
        id: 0,
        name: 'Larimar Ocean 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/larimar-ocean/larimar-ocean-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/larimar-oceanhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Larix': {
    slug: 'larix',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/larix/larix-render.png',
    products: [
      {
        id: 0,
        name: 'Larix 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/larix/larix-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/larixhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Las Palmas': {
    slug: 'las-palmas',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-render.png',
    products: [
      {
        id: 0,
        name: 'Las Palmas Carbon 100x100',
        color: 'Beige',
        size: '120x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-carbon-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Las Palmas Bej 100x100',
        color: 'Beige',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-bej-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Las Palmas Gri 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-gris-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Las Palmas White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/LAS-PALMAS-ANTRASIT-SEMILAPPATO-60X120---FACE-1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Las Palmas Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/LAS-PALMAS-ANTRASIT-SEMILAPPATO-60X120---FACE-1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Las Palmas Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Las Palmas Mocha 60x120',
        color: 'Moka',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-gris-120X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Las Palmas Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/LAS-PALMAS-ANTRASIT-SEMILAPPATO-60X120---FACE-1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Las Palmas Carbon 60x120',
        color: 'Carbon',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-gris-120X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Las Palmas Bej 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-beige-120X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Las Palmas Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-gris-120X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Las Palmas Anthracite 60x120',
        color: 'Antracit',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-anthracite-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Las Palmas Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-beige-120X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Las Palmas Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-gris-120X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 14,
        name: 'Las Palmas Anthracite 100x100',
        color: 'Beige',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-anthracite-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 15,
        name: 'Las Palmas Gris 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/LAS-PALMAS-ANTRASIT-SEMILAPPATO-60X120---FACE-1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 16,
        name: 'Las Palmas Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/LAS-PALMAS-ANTRASIT-SEMILAPPATO-60X120---FACE-1.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 17,
        name: 'Las Palmas Bej 60x120',
        color: 'Bej',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-bej-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 18,
        name: 'Las Palmas Bej 60x120',
        color: 'Bej',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-bej-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 19,
        name: 'Las Palmas Carbon 60x120',
        color: 'Carbon',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-carbon-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 20,
        name: 'Las Palmas Carbon 60x120',
        color: 'Carbon',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-carbon-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 21,
        name: 'Las Palmas Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-gris-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 22,
        name: 'Las Palmas Mocha 60x120',
        color: 'Mocha',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-mocha-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 23,
        name: 'Las Palmas Mocha 60x120',
        color: 'Mocha',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-mocha-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 24,
        name: 'Las Palmas White 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-blanc-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 25,
        name: 'Las Palmas White 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-blanc-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 26,
        name: 'Las Palmas Bej 20x120',
        color: 'Bej',
        size: '20x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/las-palmas/las-palmas-bej-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/las-palmashttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },    // typesProduit: '',
  'Lefke': {
    slug: 'lefke',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Lefke Cotto 60x60',
        color: 'Cotto',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lefke/LEFKE-COTTO-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Lefke Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lefke/LEFKE-COTTO-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Lefke Ivory 60x60',
        color: 'Ivoire',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lefke/LEFKE-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/lefkehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Limra': {
    slug: 'limra',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lefke/LEFKE-COTTO-60X60X2-MAT-P1.jpg',
    products: [
      {
        id: 0,
        name: 'Limra Bej 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/limra/limra-beige-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Limra Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/limra/limra-gris-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Limra Bej 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/limra/limra-beige-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Limra Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/limra/limra-gris-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/limrahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Lisbon': {
    slug: 'lisbon',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lisbon/lisbon.jpg',
    products: [
      {
        id: 0,
        name: 'Lisbon 30x60',
        color: '',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/lisbon/lisbon.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/lisbonhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Logs': {
    slug: 'logs',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/logs/logs-golden-oak.png',
    products: [
      {
        id: 0,
        name: 'Logs Golden Oak 20x120',
        color: 'Doré Oak',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/logs/logs-golden-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Logs Hazelnut 20x120',
        color: 'Hazelnut',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/logs/logs-golden-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Logs Light Beige 20x120',
        color: 'Clair Beige',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/logs/logs-golden-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Logs Special Walnut 20x120',
        color: 'Special Walnut',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/logs/logs-golden-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/logshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Loreto': {
    slug: 'loreto',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loreto/loreto-dark-60X60.png',
    products: [
      {
        id: 0,
        name: 'Loreto Light 60x60',
        color: 'Clair',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loreto/loreto-dark-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Loreto Dark 60x60',
        color: 'Foncé',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loreto/loreto-dark-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Loreto Light 61x61',
        color: 'Clair',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loreto/loreto-light-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Loreto Dark 61x61',
        color: 'Foncé',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loreto/loreto-dark-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/loretohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Loris': {
    slug: 'loris',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loris/loris-render.jpg',
    products: [
      {
        id: 0,
        name: 'Loris 30x90',
        color: '',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loris/loris-30X90.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Loris Dekofon 30x90',
        color: 'Dekofon ',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/loris/loris-dekofon-30X90.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/lorishttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Luca': {
    slug: 'luca',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
    products: [
      {
        id: 0,
        name: 'Luca Bone 60x60',
        color: 'Bone',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Luca Light Grey 60x60',
        color: 'Gris Clair',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Luca Taupe 60x60',
        color: 'Taupe',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Luca Bone 30x40',
        color: 'Bone',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Luca Light Grey 30x40',
        color: 'Gris Clair',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Luca Taupe 30x40',
        color: 'Taupe',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Luca Bone 20x40',
        color: 'Bone',
        size: '20x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Luca Light Grey 20x40',
        color: 'Gris Clair',
        size: '20x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Luca Taupe 20x40',
        color: 'Taupe',
        size: '20x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/luca/luca-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/lucahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Madero': {
    slug: 'madero',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madero/madero-render.png',
    products: [
      {
        id: 0,
        name: 'Madero 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madero/madero-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/maderohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Madran': {
    slug: 'madran',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madran/madran-render.png',
    products: [
      {
        id: 0,
        name: 'Madran Vanillia 60x120',
        color: 'Vanillia',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madran/madran-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Madran Mink 60x120',
        color: 'Mink',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madran/madran-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/madranhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Magellan': {
    slug: 'magellan',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magellan/magellan-bone-61X61.png',
    products: [
      {
        id: 0,
        name: 'Magellan Bone 61x61',
        color: 'Bone',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magellan/magellan-bone-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Magellan Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magellan/magellan-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Magellan Gri 61x61',
        color: 'Gris',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magellan/magellan-gris-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Magellan Antrasit 61x61',
        color: 'Anthracite',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magellan/magelnlan-antrasit-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/magellanhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Magnifique': {
    slug: 'magnifique',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magnifique/magnifique-black-30X60.png',
    products: [
      {
        id: 0,
        name: 'Magnifique Black 60x120',
        color: 'Noir',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magnifique/magnifique-black-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Magnifique Black 60x60',
        color: 'Noir',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magnifique/magnifique-black-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Magnifique Black 30x60',
        color: 'Noir',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/magnifique/magnifique-black-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/magnifiquehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Manhattan': {
    slug: 'manhattan',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-beige-45X90.png',
    products: [
      {
        id: 0,
        name: 'Manhattan Bej 45x90',
        color: 'Beige',
        size: '45x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-dunkel-gris-45X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Manhattan Gri 45x90',
        color: 'Gris',
        size: '45x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-beige-45X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Manhattan Dunkel Gri 45x90',
        color: 'Dunkel Gris',
        size: '45x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-dunkel-gris-45X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Manhattan Bej 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-beige-45X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Manhattan Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-dunkel-gris-45X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Manhattan Dunkel Gris',
        color: 'Dunkel Gris',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-dunkel-gris-45X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Manhattan Dunkel Gri 60x60',
        color: 'Dunkel Gri',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/manhattan/manhattan-dunkel-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/manhattanhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Marmol': {
    slug: 'marmol',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
    products: [
      {
        id: 0,
        name: 'Marmol Oldlace 30x90',
        color: 'Oldlace',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Marmol Oldlace Dekofon 30x90',
        color: 'Oldlace Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Marmol Oldlace Dekor 30x90',
        color: 'Oldlace Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Marmol Shadow 30x90',
        color: 'Shadow',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-shadow-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Marmol Shadow Dekofon 30x90',
        color: 'Shadow Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Marmol Shadow Dekor 30x90',
        color: 'Shadow Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Marmol Oldlace 60x60',
        color: 'Oldlace',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Marmol Shadow 60x60',
        color: 'Shadow',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marmol/marmol-oldlace-30X90.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/marmolhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Marvel': {
    slug: 'marvel',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-60x60.png',
    products: [
      {
        id: 0,
        name: 'Marvel Latte 30x90',
        color: 'Latte',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Marvel Latte Dekofon 30x90',
        color: 'Latte Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Marvel Caramel 30x90',
        color: 'Caramel',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Marvel Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-latte.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Marvel Bitter 30x90',
        color: 'Bitter',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Marvel Latte 60x60',
        color: 'Latte',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvel/marvel-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/marvelhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Marvy': {
    slug: 'marvy',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
    products: [
      {
        id: 0,
        name: 'Marvy Parlak 30x90',
        color: 'Brillant',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Marvy Parlak Dekofon 30x90',
        color: 'Brillant Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Marvy Parlak Dekor 30x90',
        color: 'Brillant Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Marvy Mat 30x90',
        color: 'Mat',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Marvy Mat Dekofon 30x90',
        color: 'Mat Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Marvy Mat Dekor 30x90',
        color: 'Mat Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Marvy Mat 60x60',
        color: 'Mat',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/marvy/marvy-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/marvyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Maryo': {
    slug: 'maryo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maryo/maryo-beige-60X120.png',
    products: [
      {
        id: 0,
        name: 'Maryo Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maryo/maryo-beige-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Maryo Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maryo/maryo-beige-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/maryohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Maxi': {
    slug: 'maxi',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxi-beyaz-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Maxi Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxy-beyaz-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Maxi Beyaz Dekofon 30x60',
        color: 'Blanc Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxi-mat-beyaz-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Maxi Beyaz Platin Dekor 30x60',
        color: 'Blanc Platin Dekor',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxi-parlak-beyaz-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Maxi Mat Beyaz 60x60',
        color: 'Mat Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxi-parlak-beyaz-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Maxi Parlak Beyaz 60x60',
        color: 'Brillant Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxi-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Maxi Parlak Beyaz 61x61',
        color: 'Brillant Blanc',
        size: '61x61',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/maxi/maxi-parlak-beyaz-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/maxihttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Merlo': {
    slug: 'merlo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/merlo/merlo.jpg',
    products: [
      {
        id: 0,
        name: 'Merlo 30x60',
        color: '',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/merlo/merlo.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/merlohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Mia': {
    slug: 'mia',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mia/mia-100X100.png',
    products: [
      {
        id: 0,
        name: 'Mia 100x100',
        color: '',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mia/mia-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Mia 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mia/mia-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Mia 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mia/mia-60X120.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/miahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Milenario': {
    slug: 'milenario',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/milenario/milenario-beige.png',
    products: [
      {
        id: 0,
        name: 'Milenario White 20x120',
        color: 'Blanc',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/milenario/milenario-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Milenario Beige 20x120',
        color: 'Beige',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/milenario/milenario-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Milenario Honey 20x120',
        color: 'Honey',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/milenario/milenario-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Milenario Grey 20x120',
        color: 'Gris',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/milenario/milenario-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Milenario Brown 20x120',
        color: 'Brun',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/milenario/milenario-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/milenariohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Minimo': {
    slug: 'minimo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/minimo/minimo-render.png',
    products: [
      {
        id: 0,
        name: 'Minimo 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/minimo/minimo-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/minimohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Miramar': {
    slug: 'miramar',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/miramar/miramar-render.png',
    products: [
      {
        id: 0,
        name: 'Miramar 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/miramar/miramar-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/miramarhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Miranda': {
    slug: 'miranda',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/miranda/miranda-render.png',
    products: [
      {
        id: 0,
        name: 'Miranda 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/miranda/miranda-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/mirandahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Mirko': {
    slug: 'mirko',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mirko/mirko-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Mirko 30x90',
        color: '',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mirko/mirko-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Mirko Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mirko/mirko-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/mirkohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Modellato': {
    slug: 'modellato',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/modellato/modellato-render.png',
    products: [
      {
        id: 0,
        name: 'Modellato 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/modellato/modellato-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/modellatohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Mood': {
    slug: 'mood',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
    products: [
      {
        id: 0,
        name: 'Mood White 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Mood Beige 30x90',
        color: 'Beige',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Mood Greige 30x90',
        color: 'Greige',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Mood Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Mood Anthracite 30x90',
        color: 'Anthracite',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Mood Oak Dekofon 30x90',
        color: 'Oak Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Mood Faber Oak Dekofon 30x90',
        color: 'Faber Oak Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Mood Bamboo Dekofon 30x90',
        color: 'Bamboo Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Mood Faber Bamboo Dekofon 30x90',
        color: 'Faber Bamboo Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Mood Faber Mix Wood Dekofon 30x90',
        color: 'Faber Mix Wood Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Mood Cement Dekofon 30x90',
        color: 'Cement Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Mood Faber Cement Dekofon 30x90',
        color: 'Faber Cement Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mood/mood-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/moodhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Mora': {
    slug: 'mora',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mora/mora.jpg',
    products: [
      {
        id: 0,
        name: 'Mora',
        color: '',
        size: '',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mora/mora.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Mora 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mora/mora.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/morahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Motto': {
    slug: 'motto',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Motto Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Motto Beyaz Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Motto Bone 30x90',
        color: 'Bone',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Motto Bone Dekofon 30x90',
        color: 'Bone Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Motto Gri 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Motto Gri Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Motto Taupe 30x90',
        color: 'Taupe',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Motto Taupe Dekofon 30x90',
        color: 'Taupe Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/motto/motto-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/mottohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Mystone': {
    slug: 'mystone',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mystone/MYSTONE-ANTHRACITE-60X60X2-MAT-P1.jpg',
    products: [
      {
        id: 0,
        name: 'Mystone Antracit ',
        color: 'Antracit ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mystone/MYSTONE-ANTHRACITE-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Mystone Café ',
        color: 'Café ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mystone/MYSTONE-ANTHRACITE-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Mystone Anthracite 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mystone/MYSTONE-ANTHRACITE-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Mystone Coffee 60x60',
        color: 'Coffee',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/mystone/MYSTONE-COFFEE-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/mystonehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Naos': {
    slug: 'naos',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/naos/naos-60X120.png',
    products: [
      {
        id: 0,
        name: 'Naos White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/naos/naos-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Naos 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/naos/naos-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/naoshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Napoli': {
    slug: 'napoli',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/napoli/napoli-fildisi.png',
    products: [
      {
        id: 0,
        name: 'Napoli Fildişi 50x50',
        color: 'Fildisi',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/napoli/napoli-fildisi.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Napoli Gri 50x50',
        color: 'Gris',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/napoli/napoli-fildisi.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/napolihttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Natura Wood': {
    slug: 'natura-wood',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/natura-wood/natura-wood-render.png',
    products: [
      {
        id: 0,
        name: 'Natura Wood Birch 20x120',
        color: 'Birch',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/natura-wood/natura-wood-birch.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Natura Wood Oak 20x120',
        color: 'Oak',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/natura-wood/natura-wood-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Natura Wood Pine 20x120',
        color: 'Pine',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/natura-wood/natura-wood-eboni.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Natura Wood Eboni 20x120',
        color: 'Eboni',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/natura-wood/natura-wood-pine.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/natura-woodhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Neva': {
    slug: 'neva',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/neva/neva-50x50.png',
    products: [
      {
        id: 0,
        name: 'Neva 30x60',
        color: '',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/neva/neva-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Neva Dekofon 30x60',
        color: 'Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/neva/neva-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Neva 50x50',
        color: '',
        size: '50x50',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/neva/neva-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/nevahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Nevada': {
    slug: 'nevada',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nevada/nevada-bone.png',
    products: [
      {
        id: 0,
        name: 'Nevada Bone 50x50',
        color: 'Bone',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nevada/nevada-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Nevada Açık Gri 50x50',
        color: 'Gris Clairs',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nevada/nevada-gris-clair.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Nevada Gri 50x50',
        color: 'Gris',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nevada/nevada-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/nevadahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'New Metro': {
    slug: 'new-metro',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/new-metro/new-metro-render.jpg',
    products: [
      {
        id: 0,
        name: 'New Metro Beyaz 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/new-metro/new-metro.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/new-metrohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Newport': {
    slug: 'newport',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/newport/newport-100X100.png',
    products: [
      {
        id: 0,
        name: 'Newport 100x100',
        color: '',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/newport/newport-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Newport 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/newport/newport-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/newporthttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Nile': {
    slug: 'nile',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-acik-gris-30X60.png',
    products: [
      {
        id: 0,
        name: 'Nile Açık Gri 60x120',
        color: 'Gris Clairs',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-acik-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Nile Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-anthracite-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Nile Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-acik-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Nile Açık Gri 60x60',
        color: 'Gris Clairs',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-acik-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Nile Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-anthracite-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Nile Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-acik-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Nile Açık Gri 30x60',
        color: 'Gris Clairs',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nile/nile-acik-gris-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/nilehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Nomerles': {
    slug: 'nomerles',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-antrasite.png',
    products: [
      {
        id: 0,
        name: 'Nomerles White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-antrasite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Nomerles Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-antrasite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Nomerles Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-antrasite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Nomerles Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Nomerles Antrasit 60x120',
        color: 'Antrasit',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-antrasite.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 5,
        name: 'Nomerles Antrasit 60x120',
        color: 'Antrasit',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-antrasite.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 6,
        name: 'Nomerles Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-gris.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 7,
        name: 'Nomerles Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-gris.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 8,
        name: 'Nomerles Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-vizon.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 9,
        name: 'Nomerles White 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-white.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 10,
        name: 'Nomerles White 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nomerles/nomerles-white.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/nomerleshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Norden': {
    slug: 'norden',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norden/norden-render.png',
    products: [
      {
        id: 0,
        name: 'Norden Teak 20x120',
        color: 'Teak',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norden/norden-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/nordenhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Nuvola': {
    slug: 'nuvola',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nuvola/nuvola-beyaz-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Nuvola Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nuvola/nuvola-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Nuvola Beyaz Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nuvola/nuvola-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Nuvola Beyaz Dekor 30x90',
        color: 'Blanc Dekor',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nuvola/nuvola-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Nuvola Beyaz Polygon Dekor 30x90',
        color: 'Blanc Polygon Dekor',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/nuvola/nuvola-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/nuvolahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Oasis': {
    slug: 'oasis',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Oasis Lila 30x90',
        color: 'Lila',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Oasis Lila Dekofon 30x90',
        color: 'Lila Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Oasis Lila Dekor 30x90',
        color: 'Lila Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Oasis Mürdüm 30x90',
        color: 'Murdum',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Oasis Mürdüm Dekofon 30x90',
        color: 'Murdum Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Oasis Mürdüm Dekor 30x90',
        color: 'Murdum Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Oasis Yeşil 30x90',
        color: 'Yesil',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Oasis Yeşil Dekofon 30x90',
        color: 'Yesil Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Oasis Yeşil Dekor 30x90',
        color: 'Yesil Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/oasis/oasis-lila-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/oasishttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Odin': {
    slug: 'odin',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/odin/odin-40X120.png',
    products: [
      {
        id: 0,
        name: 'Odin 40x120',
        color: '',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/odin/odin-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Odin Dekofon 40x120',
        color: 'Dekofon',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/odin/odin-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Odin Parlak 60x60',
        color: 'Brillant',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/odin/odin-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Odin Parlak 61x61',
        color: 'Brillant',
        size: '61x61',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/odin/odin-parlak-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/odinhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Olbia': {
    slug: 'olbia',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olbia/olbia-gris-60X120.png',
    products: [
      {
        id: 0,
        name: 'Olbia Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olbia/olbia-gris-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Olbia Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olbia/olbia-gris-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/olbiahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Olivia': {
    slug: 'olivia',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olivia/olivia-blanc.png',
    products: [
      {
        id: 0,
        name: 'Olivia Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olivia/olivia-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Olivia Siyah 30x60',
        color: 'Noir',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olivia/olivia-noir.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/oliviahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Olmo': {
    slug: 'olmo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olmo/olmo-bege.png',
    products: [
      {
        id: 0,
        name: 'Olmo Latte 20x120',
        color: 'Latte',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olmo/olmo-bege.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Olmo Beige 20x120',
        color: 'Beige',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olmo/olmo-latte.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Olmo Chestnut 20x120',
        color: 'Chestnut',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olmo/olmo-bege.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Olmo Tobacco 20x120',
        color: 'Tobacco',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olmo/olmo-bege.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Olmo Noce 20x120',
        color: 'Noce',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/olmo/olmo-bege.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/olmohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Onelia': {
    slug: 'onelia',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/onelia/onelia-render.jpg',
    products: [
      {
        id: 0,
        name: 'Onelia 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/onelia/onelia-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/oneliahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Onixia': {
    slug: 'onixia',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/onixia/onixia-gris.png',
    products: [
      {
        id: 0,
        name: 'Onixia Sand 60x120',
        color: 'Sable',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/onixia/onixia-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Onixia Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/onixia/onixia-sand.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/onixiahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Orfe': {
    slug: 'orfe',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
    products: [
      {
        id: 0,
        name: 'Orfe Bone 40x120',
        color: 'Bone',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Orfe Bone Dekofon 40x120',
        color: 'Bone Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Orfe Beige 40x120',
        color: 'Beige',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Orfe Beige Dekofon 40x120',
        color: 'Beige Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Orfe Bouquet Dekofon 40x120',
        color: 'Bouquet Dekofon',
        size: '40x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Orfe Bone 60x60',
        color: 'Bone',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orfe/orfe-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/orfehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Orla': {
    slug: 'orla',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orla/orla-bronz.png',
    products: [
      {
        id: 0,
        name: 'Orla Perla 60x120',
        color: 'Perla',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orla/orla-bronz.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Orla Bronz 60x120',
        color: 'Bronz',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orla/orla-bronz.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Orla Silver 60x120',
        color: 'Argent',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orla/orla-bronz.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Orla Platinum 60x120',
        color: 'Platinum',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/orla/orla-bronz.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/orlahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Palazzo': {
    slug: 'palazzo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/palazzo/palazzo-grey.png',
    products: [
      {
        id: 0,
        name: 'Palazzo Ivory 60x120',
        color: 'Ivoire',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/palazzo/palazzo-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Palazzo Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/palazzo/palazzo-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Palazzo Ivory 60x120',
        color: 'Ivory',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/palazzo/palazzo-ivory.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/palazzohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Palmer': {
    slug: 'palmer',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/palmer/palmer-render.png',
    products: [
      {
        id: 0,
        name: 'Palmer 61x61',
        color: '',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/palmer/Palmer.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/palmerhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Pamfilya': {
    slug: 'pamfilya',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pamfilya/pamfilya-acik-gris-60X60.png',
    products: [
      {
        id: 0,
        name: 'Pamfilya Açık Gri 60x120',
        color: 'Gris Clairs',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pamfilya/pamfilya-acik-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Pamfilya Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pamfilya/pamfilya-antrasit.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Pamfilya Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pamfilya/pamfilya-acik-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Pamfilya Açık Gri 60x60',
        color: 'Gris Clairs',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pamfilya/pamfilya-acik-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/pamfilyahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Paris': {
    slug: 'paris',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paris/paris-black-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Paris White 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paris/paris-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Paris White Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paris/paris-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Paris Black 30x90',
        color: 'Noir',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paris/paris-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Paris Black Dekofon 30x90',
        color: 'Noir Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paris/paris-white-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Paris White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paris/paris-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/parishttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Parisian': {
    slug: 'parisian',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/parisian/parisian-beyaz-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Parisian Beyaz 40x120',
        color: 'Blanc',
        size: '40x120',
        surface: 'Satiné',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/parisian/parisian-beyaz-geo-dekor-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Parisian Beyaz Dekofon 40x120',
        color: 'Blanc Dekofon',
        size: '40x120',
        surface: 'Satiné',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/parisian/parisian-beyaz-file-dekor-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Parisian Beyaz File Dekor 40x120',
        color: 'Blanc File Dekor',
        size: '40x120',
        surface: 'Satiné',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/parisian/parisian-mat-beyaz-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Parisian Beyaz Geo Dekor 40x120',
        color: 'Blanc Geo Dekor',
        size: '40x120',
        surface: 'Satiné',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/parisian/parisian-beyaz-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Parisian Mat Beyaz 60x60',
        color: 'Mat Blanc',
        size: '60x60',
        surface: 'Satiné',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/parisian/parisian-beyaz.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/parisianhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Paros': {
    slug: 'paros',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-acik-gris.png',
    products: [
      {
        id: 0,
        name: 'Paros Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Paros Taupe 30x60',
        color: 'Taupe',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Paros Açık Gri 30x60',
        color: 'Gris Clairs',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Paros Koyu Gri 30x60',
        color: 'Gris Foncés',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-beyaz.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Paros Beyaz Mozaik 30.5x30.5',
        color: 'Blanc Mozaik',
        size: '30.5x30.5',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Paros Koyu Gri Mozaik 30.5x30.5',
        color: 'Gris Foncés Mozaik',
        size: '30.5x30.5',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/paros/paros-taupe.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/paroshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Pastel': {
    slug: 'pastel',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pastel/pastel-noir-19,7x19,7.png',
    products: [
      {
        id: 0,
        name: 'Pastel Kırmızı 19.7x19.7',
        color: 'Kirmizi',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pastel/pastel-noir-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Pastel Siyah 19.7x19.7',
        color: 'Noir',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pastel/pastel-noir-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/pastelhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Pebble': {
    slug: 'pebble',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pebble/PEBBLE-LIGHT-GREY-60X60X2-MAT-P1.jpg',
    products: [
      {
        id: 0,
        name: 'Pebble Clair Gris ',
        color: 'Clair Gris ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pebble/PEBBLE-LIGHT-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Pebble Sable ',
        color: 'Sable ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pebble/PEBBLE-LIGHT-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Pebble Light Grey 60x60',
        color: 'Light Grey',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pebble/PEBBLE-LIGHT-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Pebble Sand 60x60',
        color: 'Sand',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pebble/PEBBLE-SAND-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/pebblehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Pera': {
    slug: 'pera',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-beyaz-60x60.png',
    products: [
      {
        id: 0,
        name: 'Pera White 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Pera White Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Pera Light Grey 30x90',
        color: 'Gris Clair',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-light-grey-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Pera Light Grey Dekofon 30x90',
        color: 'Clair Gris Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-grey-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Pera Grey 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-white-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Pera Grey Dekofon 30x90',
        color: 'Gris Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-light-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Pera White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-beyaz-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Pera Light Grey 60x60',
        color: 'Gris Clair',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-grery.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Pera Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/pera/pera-white.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/perahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Picasso': {
    slug: 'picasso',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
    products: [
      {
        id: 0,
        name: 'Picossa Akağaç 15x60',
        color: 'Picossa Akagac',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Picasso Çıra 15x60',
        color: 'Cira',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Picasso Vizon 15x60',
        color: 'Vizon',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Picasso Mavi 15x60',
        color: 'Mavi',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Picasso Tinder Mosaic 30.5x30.5',
        color: 'Tinder Mosaic',
        size: '30.5x30.5',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Picasso Blue Mosaic 30.5x30.5',
        color: 'Bleu Mosaic',
        size: '30.5x30.5',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/picasso/picasso-akagac.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/picassohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Piegato': {
    slug: 'piegato',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/piegato/piegato-render.png',
    products: [
      {
        id: 0,
        name: 'Piegato 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/piegato/piegato-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/piegatohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Quark': {
    slug: 'quark',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quark/quark-antrasit.png',
    products: [
      {
        id: 0,
        name: 'Quark Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quark/quark-antrasit.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Quark Moka 60x120',
        color: 'Moka',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quark/quark-antrasit.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Quark Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quark/quark-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Quark Antrasit 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quark/quark-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/quarkhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Quarzt': {
    slug: 'quarzt',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quarzt-render.png',
    products: [
      {
        id: 0,
        name: 'Quarzt Bone 45x90',
        color: 'Bone',
        size: '45x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quarzt-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Quarzt Bej 45x90',
        color: 'Beige',
        size: '45x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quartz-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Quarzt Gri 45x90',
        color: 'Gris',
        size: '45x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quartz-beige-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Quarzt Bone 60x60',
        color: 'Bone',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quarzt-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Quarzt Bej 60x60',
        color: 'Beige',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quartz-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Quarzt Gri 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quartz-gris-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Quarzt Antrasit 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/quarzt/quartz-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/quarzthttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Radiance': {
    slug: 'radiance',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Radiance',
        color: '',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/radiance/7BANT-RADIANCE-60X120X2-1504ENG-BAS3001-GS4BINARY-R6-RGB-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Radiance 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/radiance/7BANT-RADIANCE-60X120X2-1504ENG-BAS3001-GS4BINARY-R6-RGB-P1.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/radiancehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Regnum': {
    slug: 'regnum',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/radiance/7BANT-RADIANCE-60X120X2-1504ENG-BAS3001-GS4BINARY-R6-RGB-P1.jpg',
    products: [
      {
        id: 0,
        name: 'Regnum 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/regnum/regnum-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/regnumhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Rhea': {
    slug: 'rhea',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Rhea Antracit ',
        color: 'Antracit ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Rhea Gris ',
        color: 'Gris ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-grey.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Rhea Ivoire ',
        color: 'Ivoire ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Rhea Anthracite 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Rhea Grey 60x60',
        color: 'Grey',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-grey.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Rhea Ivory 60x60',
        color: 'Ivory',
        size: '60x60',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-grey.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/rheahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Rio': {
    slug: 'rio',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    products: [
      {
        id: 0,
        name: 'Rio Beige ',
        color: 'Beige ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rio/rio-beige.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Rio Foncé ',
        color: 'Foncé ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rio/rio-dark.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Rio Clair ',
        color: 'Clair ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rio/rio-light.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Rio Beige 60x120',
        color: 'Beige',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rio/rio-beige.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 4,
        name: 'Rio Dark 60x120',
        color: 'Dark',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rio/rio-dark.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 5,
        name: 'Rio Light 60x120',
        color: 'Light',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rio/rio-light.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/riohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Riva': {
    slug: 'riva',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rhea/rhea-anthracite.jpg',
    products: [
      {
        id: 0,
        name: 'Riva 30x60',
        color: '',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/riva/riva-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Riva Dekofon 30x60',
        color: 'Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/riva/riva-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Riva 50x50',
        color: '',
        size: '50x50',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/riva/riva-50x50.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/rivahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Root': {
    slug: 'root',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-ash-100X100.png',
    products: [
      {
        id: 0,
        name: 'Root Ash 100x100',
        color: 'Ash',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-ash-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Root Silver 100x100',
        color: 'Argent',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-silver-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Root Crema 60x120',
        color: 'Crema',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-ash-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Root Ash 60x120',
        color: 'Ash',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-ash-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Root Silver 60x120',
        color: 'Argent',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-ash-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Root Ash 60x120',
        color: 'Ash',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-ash-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 6,
        name: 'Root Crema 60x120',
        color: 'Crema',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-crema-60X120.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 7,
        name: 'Root Silver 60x120',
        color: 'Silver',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/root/root-silver-60X120.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/roothttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Rubi': {
    slug: 'rubi',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rubi/rubi-anthracite.png',
    products: [
      {
        id: 0,
        name: 'Rubi Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rubi/rubi-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Rubi Brown 60x120',
        color: 'Brun',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rubi/rubi-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Rubi Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rubi/rubi-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Rubi Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rubi/rubi-grey.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/rubihttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Saaga': {
    slug: 'saaga',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/saaga/saaga-anthracite.png',
    products: [
      {
        id: 0,
        name: 'Saaga Light Beige 30x40',
        color: 'Clair Beige',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/saaga/saaga-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Saaga Grey 30x40',
        color: 'Gris',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/saaga/saaga-light-beige.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Saaga Anthracite 30x40',
        color: 'Anthracite',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/saaga/saaga-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/saagahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sakura': {
    slug: 'sakura',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sakura/sakura-60X60.png',
    products: [
      {
        id: 0,
        name: 'Sakura 61x61',
        color: '',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sakura/sakura-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Sakura 60x60',
        color: '',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sakura/sakura-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/sakurahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Salamanca': {
    slug: 'salamanca',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/salamanca/salamanca-render.png',
    products: [
      {
        id: 0,
        name: 'Salamanca 20x120',
        color: '',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/salamanca/salamanca-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/salamancahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Salt Cave': {
    slug: 'salt-cave',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/salt-cave/salt-cave-render.png',
    products: [
      {
        id: 0,
        name: 'Salt Cave Ice 60x120',
        color: 'Ice',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/salt-cave/salt-cave-almond.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Salt Cave Almond 60x120',
        color: 'Almond',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/salt-cave/salt-cave-ice.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Salt Cave Taupe 60x120',
        color: 'Taupe',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/salt-cave/salt-cave-taupe.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/salt-cavehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sante': {
    slug: 'sante',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Sante White 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Sante White Decor 30x90',
        color: 'Blanc Decor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Sante Turquiose 30x90',
        color: 'Turquiose',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Sante Turquiose Decor 30x90',
        color: 'Turquiose Decor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Sante Aqua 30x90',
        color: 'Aqua',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Sante Aqua Dekofon 30x90',
        color: 'Aqua Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Sante Aqua Dekor 30x90',
        color: 'Aqua Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Sante Honey 30x90',
        color: 'Honey',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Sante Honey Dekor 30x90',
        color: 'Honey Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Sante Smoke 30x90',
        color: 'Fumée',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Sante Smoke Dekofon 30x90',
        color: 'Fumée Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Sante Smoke Dekor 30x90',
        color: 'Fumée Dekor',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Sante White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sante/sante-aqua-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/santehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sara': {
    slug: 'sara',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sara/sara-blue.png',
    products: [
      {
        id: 0,
        name: 'Sara Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sara/sara-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Sara Brown 60x120',
        color: 'Brun',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sara/sara-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Sara Green 60x120',
        color: 'Vert',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sara/sara-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Sara Blue 60x120',
        color: 'Bleu',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sara/sara-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/sarahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sarda': {
    slug: 'sarda',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sarda/sarda-render-2.jpg',
    products: [
      {
        id: 0,
        name: 'Sarda',
        color: '',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sarda/sarda-render-2.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Sarda 60x60',
        color: 'Havuz Mavi',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sarda/sarda.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/sardahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Saten': {
    slug: 'saten',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    products: [
      {
        id: 0,
        name: 'Saten Havuz Mavi 30x40',
        color: 'Havuz Mavi',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/saten/saten-havuz-lacivert.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Saten Havuz Lacivert 30x40',
        color: 'Havuz Marine',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/saten/saten-havuz-mavi.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/satenhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sativa': {
    slug: 'sativa',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: '/collection/SATIVA 61X61-2.jpg',
    products: [
      {
        id: 0,
        name: 'Sativa Bone 50x50',
        color: 'Bone',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sativa/sativa-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Sativa Cool Gri 50x50',
        color: 'Cool Gris',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sativa/sativa-bone.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/sativahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sealong': {
    slug: 'sealong',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sealong/sealong-render.png',
    products: [
      {
        id: 0,
        name: 'Sealong 60x120',
        color: '',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sealong/sealong-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/sealonghttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Sempre': {
    slug: 'sempre',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
    products: [
      {
        id: 0,
        name: 'Sempre Bianca 60x60',
        color: 'Bianca',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Sempre Rosa 61x61',
        color: 'Rosa',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-rosa-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Sempre Grigio 60x60',
        color: 'Grisgio',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-nero-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Sempre Grigio 61x61',
        color: 'Grisgio',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-grigio-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Sempre Nero 60x60',
        color: 'Nero',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Sempre Nero 61x61',
        color: 'Nero',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-nero-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Sempre Junior Bianca 60x60',
        color: 'Junior Bianca',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Sempre Junior Grigio 60x60',
        color: 'Junior Grisgio',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-rosa-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Sempre Junior Nero 60x60',
        color: 'Junior Nero',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Sempre Junior Bianca 19.7x19.7',
        color: 'Junior Bianca',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Sempre Junior Rosa 19.7x19.7',
        color: 'Junior Rosa',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Sempre Junior Grigio 19.7x19.7',
        color: 'Junior Grisgio',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Sempre Junior Nero 19.7x19.7',
        color: 'Junior Nero',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-bianca-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Sempre Grigio 60x60',
        color: 'Grisgio',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/sempre/sempre-grigio-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/semprehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Serpantin': {
    slug: 'serpatin',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    products: [
      {
        id: 0,
        name: 'Serpantin Sable ',
        color: 'Sable ',
        size: '',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/serpantin/serpantin-sand-60X120.webp',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Serpantin Blanc ',
        color: 'Blanc ',
        size: '',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/serpantin/serpantin-white-60X120.webp',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Serpantin Sand 60x120',
        color: 'Sand',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/serpantin/serpantin-sand-60X120.webp',
        faces: [''],
        specifications: {}
      },
      {
        id: 3,
        name: 'Serpantin White 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/serpantin/serpantin-white-60X120.webp',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/serpatinhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Shell': {
    slug: 'shell',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Shell',
        color: '',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/shell/7BANTSEET-SHELL-BEIGE-60X120X2-ENG1504-BAS3001-GS4BINARY-SSB3-RGB-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Shell 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/shell/7BANTSEET-SHELL-BEIGE-60X120X2-ENG1504-BAS3001-GS4BINARY-SSB3-RGB-P1.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/shellhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Side': {
    slug: 'side',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: '/collection/STACY 50X50-2.jpg',
    products: [
      {
        id: 0,
        name: 'Side Green 60x120',
        color: 'Vert',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/side/side-brown.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Side Brown 60x120',
        color: 'Brun',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/side/side-brown.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/sidehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Silyon': {
    slug: 'silyon',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/silyon/silyon-blue.png',
    products: [
      {
        id: 0,
        name: 'Silyon Blue 60x120',
        color: 'Bleu',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/silyon/silyon-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Silyon Gold 60x120',
        color: 'Or',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/silyon/silyon-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/silyonhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Simirna': {
    slug: 'simirna',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/simirna/simirna-brown.png',
    products: [
      {
        id: 0,
        name: 'Simirna Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/simirna/simirna-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Simirna Brown 60x120',
        color: 'Brun',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/simirna/simirna-brown.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/simirnahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Stacy': {
    slug: 'stacy',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/stacy/stacy-render.png',
    products: [
      {
        id: 0,
        name: 'Stacy 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/stacy/stacy-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/stacyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Star': {
    slug: 'star',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star/star-bleu-19,7x19,7.png',
    products: [
      {
        id: 0,
        name: 'Star Kırmızı 19.7x19.7',
        color: 'Kirmizi',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star/star-bleu-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Star Mavi 19.7x19.7',
        color: 'Mavi',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star/star-bleu-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/starhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Star Line': {
    slug: 'star-line',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star-line/star-line-render.png',
    products: [
      {
        id: 0,
        name: 'Star Line 30x90',
        color: '',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star-line/star-line-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Star Line Dekofon 30x90',
        color: 'Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star-line/star-line.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Star Line 60x60',
        color: '',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/star-line/star-line-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/star-linehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Statuario Goya': {
    slug: 'statuario-goya',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-render.png',
    products: [
      {
        id: 0,
        name: 'Statuario Goya 100x100',
        color: '',
        size: '100x100',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Statuario Goya 60x120',
        color: '',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Statuario Goya 60x60',
        color: '',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Statuario Goya 61x61',
        color: '',
        size: '61x61',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Statuario Goya 40x120',
        color: '',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/P015XDRSB00X0XMAAW50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Statuario Goya Dekofon 40x120',
        color: 'Dekofon',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/W168QDRSB0040XPAAW50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Statuario Goya 30x60',
        color: '',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/P156ZDRSB0TX0XMXXW50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Statuario Goya 60x120',
        color: '',
        size: '60x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-30x60.png',
        faces: [''],
        specifications: {}
      },
      {
        id: 8,
        name: 'Statuario Goya 60x60',
        color: '',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/statuario-goya/statuario-goya-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/statuario-goyahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Storm Rock': {
    slug: 'storm-rock',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-antracite.jpg',
    products: [
      {
        id: 0,
        name: 'Storm Rock Antracit',
        color: 'Antracit',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-antracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Storm Rock Cotto ',
        color: 'Cotto ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-suolo.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Storm Rock Gris ',
        color: 'Gris ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-antracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Storm Rock New Vert ',
        color: 'New Vert ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-cotto.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Storm Rock Suola 60x120',
        color: 'Suola',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-new-green.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Storm Rock Blanc ',
        color: 'Blanc ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-antracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Storm Rock Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-antracite.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 7,
        name: 'Storm Rock Cotto 60x120',
        color: 'Cotto',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-cotto.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 8,
        name: 'Storm Rock Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-gris.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 9,
        name: 'Storm Rock New Green 60x120',
        color: 'New Green',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-new-green.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 10,
        name: 'Storm Rock White 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/storm-rock/storm-rock-white.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/storm-rockhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Strato': {
    slug: 'strato',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/strato/strato-render.png',
    products: [
      {
        id: 0,
        name: 'Strato 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/strato/strato-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/stratohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Stuart': {
    slug: 'stuart',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/stuart/stuart-render.png',
    products: [
      {
        id: 0,
        name: 'Stuart 50x50',
        color: '',
        size: '50x50',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/stuart/stuart-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/stuarthttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Süper Beyaz': {
    slug: 'super-beyaz',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    products: [
      {
        id: 0,
        name: 'Süper Beyaz 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/super-beyaz/super-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Süper Beyaz 60x60',
        color: '',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/super-beyaz/super-beyaz-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Süper Beyaz 30x60',
        color: '',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/super-beyaz/super-beyaz-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/super-beyazhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Swan': {
    slug: 'swan',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: '/collection/SWAN 60x120 R1.jpg',
    products: [
      {
        id: 0,
        name: 'Swan 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/swan/swan-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/swanhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Tavas': {
    slug: 'tavas',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Tavas Crème ',
        color: 'Crème ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-CREAM-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Tavas Or ',
        color: 'Or ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-GOLD-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Tavas Gris ',
        color: 'Gris ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Tavas Noce ',
        color: 'Noce ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-LIGHT-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Tavas Clair Gris ',
        color: 'Clair Gris ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-LIGHT-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Tavas Cream 60x60',
        color: 'Cream',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-CREAM-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Tavas Gold 60x60',
        color: 'Gold',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-GOLD-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Tavas Grey 60x60',
        color: 'Grey',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Tavas Light Grey 60x60',
        color: 'Light Grey',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-LIGHT-GREY-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Tavas Noce 60x60',
        color: 'Noce',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-NOCE-60X60X2-MAT-P1.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/tavashttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Terra': {
    slug: 'terra',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tavas/TAVAS-CREAM-60X60X2-MAT-P1.jpg',
    products: [
      {
        id: 0,
        name: 'Terra Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/terra/terra-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Terra Gri 30x90',
        color: 'Gris',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/terra/terra-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Terra Turkuaz 30x90',
        color: 'Turkuaz',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/terra/terra-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Terra Gül Kurusu 30x90',
        color: 'Gul Kurusu',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/terra/terra-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Terra Mix Dekofon 30x90',
        color: 'Mix Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/terra/terra-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Terra Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/terra/terra-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/terrahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Thanos': {
    slug: 'thanos',
    categories: ['Jardin'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/thanos/thanos-acik-gris.png',
    products: [
      {
        id: 0,
        name: 'Thanos Sand 60x120',
        color: 'Sable',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/thanos/thanos-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Thanos Açık Gri 60x120',
        color: 'Gris Clairs',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/thanos/thanos-sand-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Thanos Koyu Gri 60x120',
        color: 'Gris Foncés',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/thanos/thanos-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Thanos Sand 60x60',
        color: 'Sable',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/thanos/thanos-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Thanos Koyu Gri 60x60',
        color: 'Gris Foncés',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/thanos/thanos-sand.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/thanoshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Tiana': {
    slug: 'tiana',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiana/tiana-antrasit-40X120.png',
    products: [
      {
        id: 0,
        name: 'Tiana Beyaz 40x120',
        color: 'Blanc',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiana/tiana-blanc-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Tiana Antrasit 40x120',
        color: 'Anthracite',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiana/tiana-blanc-40x120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Tiana Dekofon 40x120',
        color: 'Dekofon',
        size: '40x120',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiana/tiana-antrasit-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Tiana Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiana/tiana-antrasit-40X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/tianahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Tiffany': {
    slug: 'tiffany',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiffany/tiffany-bleu.png',
    products: [
      {
        id: 0,
        name: 'Tiffany Yeşil 19.7x19.7',
        color: 'Yesil',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiffany/tiffany-bleu.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Tiffany Mavi 19.7x19.7',
        color: 'Mavi',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiffany/tiffany-bleu.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Tiffany Siyah 19.7x19.7',
        color: 'Noir',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiffany/tiffany-bleu.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/tiffanyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Tiger': {
    slug: 'tiger',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiger/tiger-render.png',
    products: [
      {
        id: 0,
        name: 'Tiger Black 60x120',
        color: 'Noir',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tiger/Tiger.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/tigerhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Tsuga': {
    slug: 'tsuga',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tsuga/tsuga-almond.png',
    products: [
      {
        id: 0,
        name: 'Tsuga Natural 20x120',
        color: 'Naturel',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tsuga/tsuga-almond.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Tsuga Almond 20x120',
        color: 'Almond',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tsuga/tsuga-almond.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Tsuga Maun 20x120',
        color: 'Maun',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tsuga/tsuga-almond.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/tsugahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Turin': {
    slug: 'turin',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/turin/turin-gris-100X100.png',
    products: [
      {
        id: 0,
        name: 'Turin Gris 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/turin/turin-gris-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Turin Gri 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/turin/turin-gris-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/turinhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Twist': {
    slug: 'twist',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/twist/twist-blanc.png',
    products: [
      {
        id: 0,
        name: 'Twist Beyaz 14.2x16.4',
        color: 'Blanc',
        size: '14.2x16.4',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/twist/twist-blanc.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Twist Gri 14.2x16.4',
        color: 'Gris',
        size: '14.2x16.4',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/twist/twist-noir.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Twist Siyah 14.2x16.4',
        color: 'Noir',
        size: '14.2x16.4',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/twist/twist-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/twisthttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Urban': {
    slug: 'urban',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
    products: [
      {
        id: 0,
        name: 'Urban Bone 60x60',
        color: 'Bone',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Urban Bone 61x61',
        color: 'Bone',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-bone-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Urban Latte 60x60',
        color: 'Latte',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Urban Latte 61x61',
        color: 'Latte',
        size: '61x61',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-latte-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Urban Dunkel 60x60',
        color: 'Dunkel',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Urban Anthracite 60x60',
        color: 'Anthracite',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/D150XDRU010V0XMAAF50.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Urban Bone 30x60',
        color: 'Bone',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Urban Latte 30x60',
        color: 'Latte',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Urban Dunkel Muretto Mosaic 30x68',
        color: 'Dunkel Muretto Mosaic',
        size: '30x68',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Urban Anthracite Muretto Mosaic 30x68',
        color: 'Anthracite Muretto Mosaic',
        size: '30x68',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/D150XDRU010V0XMAAG60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Urban Bone 30x40',
        color: 'Bone',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Urban Dunkel 30x40',
        color: 'Dunkel',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Urban Anthracite 30x40',
        color: 'Anthracite',
        size: '30x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-bone-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Urban Bone 20x40',
        color: 'Bone',
        size: '20x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 14,
        name: 'Urban Dunkel 20x40',
        color: 'Dunkel',
        size: '20x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 15,
        name: 'Urban Anthracite 20x40',
        color: 'Anthracite',
        size: '20x40',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-latte-30x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 16,
        name: 'Urban Bone 197x197',
        color: 'Bone',
        size: '197x197',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 17,
        name: 'Urban Dunkel 197x197',
        color: 'Dunkel',
        size: '197x197',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 18,
        name: 'Urban Anthracite 197x197',
        color: 'Anthracite',
        size: '197x197',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-bone-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 19,
        name: 'Urban Anthracite 19.7x19.7',
        color: 'Anthracite',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-anthracite-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 20,
        name: 'Urban Bone 19.7x19.7',
        color: 'Bone',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-bone-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 21,
        name: 'Urban Dunkel 19.7x19.7',
        color: 'Dunkel',
        size: '19.7x19.7',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/urban/urban-dunkel-19,7x19,7.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/urbanhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Vales': {
    slug: 'vales',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vales/vales-render.jpg',
    products: [
      {
        id: 0,
        name: 'Vales',
        color: '',
        size: '',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vales/vales-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Vales 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vales/vales.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/valeshttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Valor': {
    slug: 'valor',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/valor/valor-black-dekofon.png',
    products: [
      {
        id: 0,
        name: 'Valor White 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/valor/valor-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Valor White Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/valor/valor-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Valor Black 30x90',
        color: 'Noir',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/valor/valor-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Valor Black Dekofon 30x90',
        color: 'Noir Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/valor/valor-white-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Valor White 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/valor/valor-black-dekofon.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/valorhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Vedra Grafit': {
    slug: 'vedra-grafit',
    categories: ['Jardin'],
    products: [
      {
        id: 0,
        name: 'Vedra Grafit 60x60',
        color: '',
        size: '60x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vedra-graphite/Vedra.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/vedra-grafithttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Venis': {
    slug: 'venis',
    categories: ['Jardin'],
    mainImage: '/collection/VERONA 30X60.jpg',
    products: [
      {
        id: 0,
        name: 'Venis Antracit ',
        color: 'Antracit ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Venis Gris ',
        color: 'Gris ',
        size: '',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Venis Anthracite 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-anthracite.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 3,
        name: 'Venis Grey 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-gris.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/venishttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Venüs': {
    slug: 'venus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    products: [
      {
        id: 0,
        name: 'Venüs White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Venüs Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Venüs Vizon 60x120',
        color: 'Vizon',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/venis/venis-anthracite.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/venushttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Verona': {
    slug: 'verona',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: '/collection/VERONA 30X60.jpg',
    products: [
      {
        id: 0,
        name: 'Verona 30x60',
        color: '',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/verona/verona-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/veronahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Vigo': {
    slug: 'vigo',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vigo/vigo-60x60.png',
    products: [
      {
        id: 0,
        name: 'Vigo Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vigo/vigo-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Vigo Beyaz Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vigo/vigo-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Vigo Beyaz 60x60',
        color: 'Blanc',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vigo/vigo-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/vigohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Vintage': {
    slug: 'vintage',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    products: [
      {
        id: 0,
        name: 'Vintage 60x120',
        color: '',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vintage/vintage-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/vintagehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Violeta': {
    slug: 'violeta',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vintage/vintage-render.jpg',
    products: [
      {
        id: 0,
        name: 'Violeta Cafe Parlak 60x60',
        color: 'Café Brillant',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/violeta/violeta-cafe-parlak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Violata Gris Parlak 60x60',
        color: 'Violata Gris Brillant',
        size: '60x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/violeta/violeta-cafe-parlak.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/violetahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Vitray': {
    slug: 'vitray',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vitray/vitray-render.jpg',
    products: [
      {
        id: 0,
        name: 'Vitray 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/vitray/vitray-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/vitrayhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Void': {
    slug: 'void',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
    products: [
      {
        id: 0,
        name: 'Void Bone 120x120',
        color: 'Bone',
        size: '120x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Void Bone 100x100',
        color: 'Bone',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Void Grej 100x100',
        color: 'Grej',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-grej-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Void Gri 100x100',
        color: 'Gris',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-gris-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Void Füme 100x100',
        color: 'Fumée',
        size: '100x100',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-fume-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Void Bone 60x120',
        color: 'Bone',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 6,
        name: 'Void Grej 60x120',
        color: 'Greige',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 7,
        name: 'Void Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-fume-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 8,
        name: 'Void Bone 60x60',
        color: 'Bone',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 9,
        name: 'Void Bone 61x61',
        color: 'Bone',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 10,
        name: 'Void Grej 60x60',
        color: 'Greige',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 11,
        name: 'Void Grej 61x61',
        color: 'Greige',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-grej-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 12,
        name: 'Void Grey 60x60',
        color: 'Gris',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-gris-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 13,
        name: 'Void Grey 61x61',
        color: 'Gris',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-gris-61X61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 14,
        name: 'Void Füme 60x60',
        color: 'Fumée',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 15,
        name: 'Void Füme 61x61',
        color: 'Fumée',
        size: '61x61',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-fume-61x61.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 16,
        name: 'Void White 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-60X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 17,
        name: 'Void White Dekofon 30x60',
        color: 'Blanc Dekofon',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-fume-60x60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 18,
        name: 'Void Bone 30x60',
        color: 'Bone',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 19,
        name: 'Void Bone Dekofon 30x60',
        color: 'Bone Dekofon',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 20,
        name: 'Void Grej 30x60',
        color: 'Greige',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 21,
        name: 'Void Grey 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-gris-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 22,
        name: 'Void Grey Dekofon 30x60',
        color: 'Gris Dekofon',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-gris-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 23,
        name: 'Void Füme 30x60',
        color: 'Fumée',
        size: '30x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-100X100.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 24,
        name: 'Void Bone 20x120',
        color: 'Bone',
        size: '20x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/void/void-bone-60X120.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/voidhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Volare': {
    slug: 'volare',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine', 'Extérieur'],
    products: [
      {
        id: 0,
        name: 'Volare Grey 60x120',
        color: 'Gris',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/volare/volare-gris.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Volare Light Grey 60x120',
        color: 'Gris Clair',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/volare/volare-light-gris.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Volare Taupe 60x120',
        color: 'Taupe',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/volare/volare-taupe.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Volare White 60x120',
        color: 'Blanc',
        size: '60x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/volare/volare-white.jpg',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/volarehttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Walter': {
    slug: 'walter',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/volare/volare-gris.jpg',
    products: [
      {
        id: 0,
        name: 'Walter Açık Gri 30x60',
        color: 'Gris Clairs',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/walter/walter-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Walter Gri 30x60',
        color: 'Gris',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/walter/walter-anthracite.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Walter Antrasit 30x60',
        color: 'Anthracite',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/walter/walter-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Walter Dekofon 30x60',
        color: 'Dekofon',
        size: '30x60',
        surface: 'Brillant',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/walter/walter-acik-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/walterhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Wario': {
    slug: 'wario',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/wario/wario-blue.png',
    products: [
      {
        id: 0,
        name: 'Wario Green 60x120',
        color: 'Vert',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/wario/wario-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Wario Blue 60x120',
        color: 'Bleu',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/wario/wario-blue.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/wariohttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'White Star': {
    slug: 'white-star',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/white-star/white-star-render.png',
    products: [
      {
        id: 0,
        name: 'White Star 60x120',
        color: '',
        size: '60x120',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/white-star/white-star-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'White Star 60x60',
        color: '',
        size: '60x60',
        surface: 'Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/white-star/white-star-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/white-starhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Windy': {
    slug: 'windy',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/windy/windy-render.jpg',
    products: [
      {
        id: 0,
        name: 'Windy 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/windy/windy-render.jpg',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Windy 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/windy/windy.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/windyhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Yoga Wood': {
    slug: 'yoga-wood',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yoga-wood/yoga-wood-render.png',
    products: [
      {
        id: 0,
        name: 'Yoga Wood Ivory 20x120',
        color: 'Ivoire',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yoga-wood/yoga-wood-oak.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Yoga Wood Oak 20x120',
        color: 'Oak',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yoga-wood/yoga-wood-gris.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Yoga Wood Grey 20x120',
        color: 'Gris',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yoga-wood/yoga-wood-ivory.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Yoga Wood Venge 20x120',
        color: 'Venge',
        size: '20x120',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yoga-wood/yoga-wood-yenge.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/yoga-woodhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Yuta': {
    slug: 'yuta',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
    products: [
      {
        id: 0,
        name: 'Yuta Beyaz Dekofon 30x90',
        color: 'Blanc Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Yuta Beyaz 30x90',
        color: 'Blanc',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Yuta Krem 30x90',
        color: 'Crème',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Yuta Krem Dekofon 30x90',
        color: 'Crème Dekofon',
        size: '30x90',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 4,
        name: 'Yuta Beyaz 30x60',
        color: 'Blanc',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 5,
        name: 'Yuta Krem 30x60',
        color: 'Crème',
        size: '30x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/yuta/yuta-blanc-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/yutahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Zenith': {
    slug: 'zenith',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zenith/zenith-30X60.png',
    products: [
      {
        id: 0,
        name: 'Zenith 60x120',
        color: '',
        size: '60x120',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zenith/zenith-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Zenith 60x60',
        color: '',
        size: '60x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zenith/zenith-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Zenith 30x60',
        color: '',
        size: '30x60',
        surface: 'Full Lappato',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zenith/zenith-30X60.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 3,
        name: 'Zenith 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zenith/zenith-60X120.png',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/zenithhttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },
  'Zigana': {
    slug: 'zigana',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zigana/zigana-render.png',
    products: [
      {
        id: 0,
        name: 'Zigana Beyaz 15x60',
        color: 'Blanc',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zigana/zigana-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 1,
        name: 'Zigana Meşe 15x60',
        color: 'Chêne',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zigana/zigana-render.png',
        faces: [
          ''
        ],
        specifications: {}
      },
      {
        id: 2,
        name: 'Zigana Ceviz 15x60',
        color: 'Noyer',
        size: '15x60',
        surface: 'Mat',
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/zigana/zigana-render.png',
        faces: [
          ''
        ],
        specifications: {}
      }
    ],
    documents: [
      // Exemple: { name: 'Fiche Produit', file: '/collections/ziganahttps://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/docs/fiche.pdf', size: '' }
    ],
    specs: {
      // À remplir depuis le PDF produit
      // finition: '',
      // epaisseur: '',
      // rectifie: '',
      // typesProduit: '',
    }
  },

  'Carney 3D Plus': {
    slug: 'carney-3d-plus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-white.jpg',
    products: [
      { id: 0, name: 'Carney Anthracite', color: 'Anthracite', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-anthracite.jpg', faces: [''], specifications: {} },
      { id: 1, name: 'Carney Grey', color: 'Gris', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-grey.jpg', faces: [''], specifications: {} },
      { id: 2, name: 'Carney White', color: 'Blanc', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-white.jpg', faces: [''], specifications: {} },
      {
        id: 3,
        name: 'Carney Anthracite 3D Plus 60x120',
        color: 'Anthracite',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-anthracite.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 4,
        name: 'Carney Grey 3D Plus 60x120',
        color: 'Grey',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-grey.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 5,
        name: 'Carney White 3D Plus 60x120',
        color: 'White',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/carney-3d-plus/carney-white.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Corten 3D': {
    slug: 'corten-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: ['https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/corten-3d/corten-3d-render.jpg'],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/corten-3d/corten-3d-render.jpg',
    products: [
      { id: 0, name: 'Corten 3D', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/corten-3d/corten-3D.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Corten 3D 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/corten-3d/corten-3D.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Kelvin 3D Plus': {
    slug: 'kelvin-3d-plus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kelvin-3d-plus/kelvin-3D-plus.jpg',
    products: [
      { id: 0, name: 'Kelvin 3D Plus', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kelvin-3d-plus/kelvin-3D-plus.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Kelvin 3D Plus 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/kelvin-3d-plus/kelvin-3D-plus.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Madiolux 3D': {
    slug: 'madiolux-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madiolux-3d/madiolux.jpg',
    products: [
      { id: 0, name: 'Madiolux 3D', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madiolux-3d/madiolux.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Madiolux 3D 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/madiolux-3d/madiolux.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Norm 3D': {
    slug: 'norm-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norm-3d/norm-pine.jpg',
    products: [
      { id: 0, name: 'Norm Cherry', color: 'Cerisier', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norm-3d/norm-cherry.jpg', faces: [''], specifications: {} },
      { id: 1, name: 'Norm Pine', color: 'Pin', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norm-3d/norm-pine.jpg', faces: [''], specifications: {} },
      {
        id: 2,
        name: 'Norm Cherry 3D 60x120',
        color: 'Cherry',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norm-3d/norm-cherry.jpg',
        faces: [''],
        specifications: {}
      },
      {
        id: 3,
        name: 'Norm Pine 3D 60x120',
        color: 'Pine',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/norm-3d/norm-pine.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Optima 3D Plus': {
    slug: 'optima-3d-plus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/optima-3d-plus/optima.jpg',
    products: [
      { id: 0, name: 'Optima 3D Plus', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/optima-3d-plus/optima.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Optima 3D Plus 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/optima-3d-plus/optima.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Rigel 3D': {
    slug: 'rigel-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rigel-3d/P156ZDRR61SX0XMAAW10-1.jpg',
    products: [
      { id: 0, name: 'Rigel 3D', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rigel-3d/P156ZDRR61SX0XMAAW10-1.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Rigel 3D 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/rigel-3d/P156ZDRR61SX0XMAAW10-1.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Selena 3D Plus': {
    slug: 'selena-3d-plus',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/selena-3d-plus/P156ZDRSI5SX0XPAAK30-1.jpg',
    products: [
      { id: 0, name: 'Selena 3D Plus', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/selena-3d-plus/P156ZDRSI5SX0XPAAK30-1.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Selena 3D Plus 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/selena-3d-plus/P156ZDRSI5SX0XPAAK30-1.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Serpegiante 3D': {
    slug: 'serpegiante-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: '',
    products: [
      {
        id: 0,
        name: 'Serpegiante 3D 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: '',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Tempo 3D': {
    slug: 'tempo-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tempo-3d/P156ZDRD59SX0XMAAG40-1.jpg',
    products: [
      { id: 0, name: 'Tempo 3D', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tempo-3d/P156ZDRD59SX0XMAAG40-1.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Tempo 3D 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/tempo-3d/P156ZDRD59SX0XMAAG40-1.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Timber 3D': {
    slug: 'timber-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/timber-3d/timber.jpg',
    products: [
      { id: 0, name: 'Timber 3D', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/timber-3d/timber.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Timber 3D 60x120',
        color: '',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/timber-3d/timber.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
  'Traverten 3D': {
    slug: 'traverten-3d',
    categories: ['Salle de Bain', 'Intérieur', 'Cuisine'],
    renders: [],
    mainImage: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/traverten-3d/traverten.jpg',
    products: [
      { id: 0, name: 'Traverten 3D', color: '', size: '', surface: 'Mat', thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/traverten-3d/traverten.jpg', faces: [''], specifications: {} },
      {
        id: 1,
        name: 'Traverten Beige 3D 60x120',
        color: 'Beige',
        size: '60x120',
        surface: null,
        thumbnail: 'https://cdn.jsdelivr.net/gh/kebab34/sra@cd408c4/public/tiles/traverten-3d/traverten.jpg',
        faces: [''],
        specifications: {}
      }
    ],
    documents: [], commonSpecs: {},
  },
};
